import { AfterViewInit, AfterViewChecked, Component, Input, ViewChild, OnInit, OnDestroy, output, ChangeDetectorRef } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { Drawer } from 'primeng/drawer';
import { CommonHttpService, CommonService, GroupingService, GroupInfo, SpinnerService } from '../../shared/services';
import { Router, ActivatedRoute } from '@angular/router';
import { GenerateReportFormComponent } from '../../shared/components/generate-report-form/generate-report-form.component';
import { ExportResponse, ReportFormData, ExportType, SortColumn, ValidDataType, ReportType, FilterType, GraphType, GraphCategory, GraphItem, isValidGraphType } from './interfaces/report-details.interface';
import { CommonMethods, Severity } from '../../shared/helpers/common-methods';
import { TalentBenchReportOptions, TeamsAndRolesResponse } from '../../shared/components/generate-report-form/interfaces/generate-report-form.interface';
import { TimezoneTransformPipe } from '../../shared/pipes/timezone-transform.pipe';
import { toCalendarDate } from '../../shared/helpers/calendar-date.utils';
import { SavedReportService } from '../../shared/services/saved-report.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BaseChartService } from '../../shared/services/base-chart.service';
import { ConfirmationService } from 'primeng/api';
import { ConfigService } from '../../app-config.service';
import { HierarchyService } from './services/hierarchy.service';
import { HierarchyReportData, HierarchyColumn, HierarchyDataRow } from './interfaces/hierarchy.interface';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'bi-report-details',
  templateUrl: './report-details.component.html',
  styleUrl: './report-details.component.scss',
  standalone: false
})
export class ReportDetailsComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  private previousGenerateReportFormState: boolean = false;
  public isInitialLoad: boolean = true; // Track if this is the first load

  // Search form controls
  searchForm!: FormGroup;
  columnLevelOptions: { [key: string]: any[] } = {};

  visible2: boolean = false;
  jobDescriptionDrawer: boolean = false;
  showJobDescriptionPopup: boolean = false;
  getReportPostData: any = {};
  notesCreatedAt: string = '';
  notesDescription: string = '';
  notesCreatedBy: string = '';
  ngAfterViewChecked(): void {
    // Only execute once after all view is loaded
    if (this.generateReportForm && !this.previousGenerateReportFormState && this.isDataLoaded) {
      // Validate report form after sending data to child component
      this.generateReportForm.validateReportForm();
      this.previousGenerateReportFormState = true;
    }
  }

  // Expose enums to template
  ReportType = ReportType;
  filterType = FilterType;
  GraphType = GraphType;
  GraphCategory = GraphCategory;
  date: Date[] | undefined;
  dateRange: Date[] | undefined;
  tableExportItems: MenuItem[] = [];
  graphExportItems: MenuItem[] = [];
  isGraphReport: 1 | 0 = 0;
  graphItems!: MenuItem[] | [];
  allGraphItems!: MenuItem[] | [];
  defaultGraphItems!: MenuItem[] | [];
  isGraphMenuExpanded: boolean = false;
  isMultiLineGraph: boolean = false;
  selectedGraphItem: GraphType = GraphType.LINE_CHART;
  itemsSetting: MenuItem[] | undefined;
  checked: boolean = true;
  radio!: string;
  reportData: any[] = [];
  groupedData: GroupInfo[] = [];
  totalRecords: number = 0;
  hasReportData: boolean = false;
  loadedSavedReportData: boolean = false;
  isDataLoaded: boolean = false;
  reportId: number = 0;
  moduleId: number = 0;
  allColumnsData: any = {};
  dimensionColumnsData: any = {};
  private columnInfoCache = new Map<string, any>();
  private dimensionColumnLookup: Record<string, any> = {};
  private unifiedTableColumnsCache: any[] = [];
  private unifiedTableColumnsCacheKey = '';
  defaultDateFormat: string = 'dd.mm.yy';
  loggedInUserTimeZone: string = '';
  defaultTimeZone: string = '';
  rowsPerPageOptions: any[] = [10, 20, 50, 100];
  drilldownReportInfo: any = {};
  drilldownColumnInfo: any = {};
  drilldownReportPostData: any = {};
  mobileReportInfo: any = {};
  refreshReportsList = output<any>();
  // Default date ranges on report details page
  defaultDateRanges: any[] = [{ name: 'T', code: '1' }, { name: 'Y', code: '2' }, { name: 'CW', code: '3' }, { name: 'LW', code: '5' }, { name: 'MTD', code: '4' }, { name: 'CM', code: '50' }, { name: 'LM', code: '11' }, { name: 'YTD', code: '12' }, { name: 'All', code: '18' }];
  // Pagination properties
  first: number = 0;
  rows: number = 20;
  loading: boolean = false;
  tableHeight: string = '400px';
  companyReports: any = {};
  companyReportsSubMenuDisplay: boolean = false;

  // Properties for show more functionality
  showMoreStates: { [key: number]: boolean } = {};
  initialDisplayCount: number = 5;

  // Properties for search functionality
  selectedModuleId: number | null = null;
  searchText: string = '';
  
  // Store applied filters (filters that were actually searched)
  appliedColumnFilters: any[] = [];
  readonly maxVisibleFilterChips: number = 3;
  originalCompanyReports: any = {}; // Store original data for filtering
  actionType: any = 1;


  // Properties for column sorting
  columnSortStates: { [key: string]: string | boolean } = {}; // 'asc', 'desc', or boolean for ngModel

  // Properties for null/not null filters
  columnNullStates: { [key: string]: string | boolean } = {}; // 'not_null', 'null', or boolean for ngModel

  // Expose Object for template use
  Object = Object;

  @Input() reportFormData: ReportFormData = {};
  @Input() reportConfig: any = {};
  @Input() userConfig: any = {};
  @Input() dimensionColumnsOptions: any = [];
  @Input() savedReportData: any = {};

  @Input() teamsAndRolesResponse: TeamsAndRolesResponse = {
    success: 1,
    userRestrictionFields: {},
    teamData: {
      teamNames: [],
      teamMembers: {}
    },
    roles: []
  };

  @Input() talentBenchReportOptions: TalentBenchReportOptions = {
    statuses: [],
    subStatuses: {}
  };

  stages: { code: any; name: any }[] = [];
  usersListOptions: { code: any; name: any }[] = [];
  private conversionRatioFieldsPromise: Promise<boolean> | null = null;
  private usersListPromise: Promise<boolean> | null = null;

  @ViewChild('drawerRef') drawerRef!: Drawer;
  @ViewChild(GenerateReportFormComponent, { static: false }) generateReportForm!: GenerateReportFormComponent;
  @ViewChild('reportmenu') reportMenu!: Menu;
  @ViewChild('datePicker') datePicker!: any;
  @ViewChild('multiDatePicker') multiDatePicker!: any;
  @ViewChild('moreFiltersPopover') moreFiltersPopover!: any;
  reportsData: any;

  enableCustomReportApi: boolean = false;
  customReportApiPopup: boolean = false;
  customReportApiLoading: boolean = false;
  servicesBaseUrl: string = '';
  createAuthTokenUrl: string = '';
  apiConfig: any = {};
  apiConfigUrl: string = '';

  // Job Description Dialog
  currentJobId: string = '';
  currentJobDescription: string = '';
  currentJobTitle: string = '';
  jobCode: string = '';

  // Hierarchy-related properties
  hierarchyData: HierarchyReportData | null = null;
  hierarchyColumns: HierarchyColumn[] = [];
  showHierarchyReport: boolean = false;
  isHierarchyData: boolean = false;

  constructor(
    private _commonService: CommonService,
    private router: Router,
    private _commonHttpService: CommonHttpService,
    private activatedRoute: ActivatedRoute,
    private _groupingService: GroupingService,
    private _commonMethods: CommonMethods,
    private timezoneTransformPipe: TimezoneTransformPipe,
    private savedReportService: SavedReportService,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private baseChartService: BaseChartService,
    private confirmationService: ConfirmationService,
    private _configService: ConfigService,
    private hierarchyService: HierarchyService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _spinnerService: SpinnerService
  ) {
    this.servicesBaseUrl = this._configService.get.call(this._configService, 'platform')?.servicesBaseUrl || '';
    this.createAuthTokenUrl = this._configService.get.call(this._configService, 'platform')?.createAuthTokenUrl || '';
    this.apiConfigUrl = this._configService.get.call(this._configService, 'platform')?.apiConfigUrl || '';
    // Initialize search form
    this.searchForm = this.fb.group({
      searchColumns: this.fb.array([])
    });

    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state;
    this.reportFormData = (state?.['reportFormData'] || {});

    this.reportConfig = (state?.['reportConfig'] || {});
    this.userConfig = (state?.['userConfig'] || {});
    if (Object.keys(this.userConfig).length > 0) {
      this.defaultDateFormat = this.userConfig.dateFormat;
      this.loggedInUserTimeZone = this.userConfig.loggedInUserTimeZone;
      this.defaultTimeZone = this.userConfig.defaultTimeZone;
      this.enableCustomReportApi = this.userConfig.enableCustomReportApi;
    }
    this.dimensionColumnsOptions = (state?.['dimensionColumnsOptions'] || []);
    this.rebuildDimensionColumnLookup(this.dimensionColumnsOptions);
    this.teamsAndRolesResponse = (state?.['teamsAndRolesResponse'] || {});
    this.talentBenchReportOptions = (state?.['talentBenchReportOptions'] || {});
    this.activatedRoute.paramMap.subscribe(async params => {
      this.moduleId = Number(params.get('moduleId'));
      this.reportId = Number(params.get('reportId'));

      if (this.reportId && this.moduleId) {
        if (!this.isInitialLoad) {
          this.clearColumnLevelFilters();
          this.first = 0;
        }
        this.loadedSavedReportData = false;
        this.savedReportData = {};
        this.reportConfig = {};
        this.reportFormData = {};
        if (this.isInitialLoad) {
          this.isInitialLoad = false;
          await this.patchDynamicSavedReportData();
        } else {
          await this.patchDynamicSavedReportData({ reportId: this.reportId, id: this.moduleId });
        }
      } else {
        if (!this.isInitialLoad && Object.keys(this.reportConfig).length > 0) {
          this.loadedSavedReportData = false;
          this.savedReportData = {};
          this.reportConfig = {};
          this.reportFormData = {};
        }
        await this.patchDynamicSavedReportData();
      }
    });
  }


  // Graph report state observable for template binding
  graphReportState: any;
  private isProcessingSavedReportData: boolean = false;
  private savedReportDataSubscription: any;
  private defaultGraphTypeSubscription: any;
  currentDefaultGraphType: any = null;

  closeCallback(e: any): void {
    this.drawerRef.close(e);
    this.companyReportsSubMenuDisplay = false;
    // Clear the selected module and search text
    this.selectedModuleId = null;
    this.searchText = '';
    this.companyReports = this.originalCompanyReports; // Reset to original data
  }

  /**
   * Handle drawer hide event to clear module and search data
   */
  onDrawerHide(e: any): void {
    // Clear the selected module and search text when drawer is hidden
    this.selectedModuleId = null;
    this.searchText = '';
    this.companyReports = this.originalCompanyReports; // Reset to original data
  }

  ngOnInit() {
    // Initialize graph report state observable for template binding
    this.graphReportState = this._commonService.graphReportState;

    this._commonHttpService.getReports.subscribe(getReports => {
      this.reportsData = getReports;
    });

    // Subscribe to getSavedReportData triggers from other components
    this.savedReportDataSubscription = this._commonService.getSavedReportDataState.subscribe((data: any) => {
      if (data && data.moduleId && data.reportId && data.reloadSavedReportData && !this.isProcessingSavedReportData) {
        this.isProcessingSavedReportData = true;
        // Update security flag immediately for UI responsiveness
        if (this.savedReportData && this.savedReportData.savedReports && this.savedReportData.savedReports[0]) {
          this.savedReportData.savedReports[0].isReportLevelSecurity = 1;
        }
        this.getSavedReportData({ reportId: data.reportId, id: data.moduleId }).then(() => {
          this._commonService.clearReloadSavedReportData();
          this.isProcessingSavedReportData = false;
        });
      }
    });

    // Subscribe to defaultGraphType changes
    this.defaultGraphTypeSubscription = this._commonService.defaultGraphType.subscribe((graphType: any) => {
      if (graphType) {
        this.applySelectedGraphType(graphType);
      }
    });

    // Handle query parameters for Google Sheets authentication
    this.handleQueryParams();

    // Initialize date range if values exist
    if (this.reportFormData.custStartDate && this.reportFormData.custEndDate) {
      this.updateDateRange(this.reportFormData.custStartDate, this.reportFormData.custEndDate);
    }


    if (!this.reportFormData) {
      //this.router.navigate(['/']);
      //return;
    }
    this.setTableHeight();
    window.addEventListener('resize', this.setTableHeight.bind(this));
    /* this.allGraphItems = [
      {
        label: 'Graphs',  //graph_type 1 single y axis,graph_type 2 multi graph
        items: [
          {
            identity: GraphType.LINE_CHART,
            graph_type: GraphCategory.MULTI_GRAPH,
            type: 0,
            label: 'Line',
            image: 'assets/images/line.svg',
            class: 'active'
          },
          {
            identity: GraphType.STACKED_COLUMN_CHART,
            graph_type: GraphCategory.MULTI_GRAPH,
            type: 0,
            label: 'Stacked Column',
            image: 'assets/images/clustered-column.svg'
          },
          {
            identity: GraphType.STACKED_AREA_CHART,
            graph_type: GraphCategory.MULTI_GRAPH,
            type: 0,
            label: 'Stacked Area',
            image: 'assets/images/stacked-area.svg'
          },
          {
            identity: GraphType.RANGE_AREA_CHART,
            graph_type: GraphCategory.MULTI_GRAPH,
            type: 0,
            label: 'Range Area',
            image: 'assets/images/range-area.svg'
          },
          {
            identity: GraphType.NESTED_DONUT_CHART,
            graph_type: GraphCategory.MULTI_GRAPH,
            type: 0,
            label: 'Nested Donut',
            image: 'assets/images/nested-donut.svg'
          },
          {
            identity: GraphType.CLUSTERED_COLUMN_CHART,
            graph_type: GraphCategory.MULTI_GRAPH,
            type: 0,
            label: 'Clustered Column',
            image: 'assets/images/clustered-column.svg'
          },
          {
            identity: GraphType.PIE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Pie',
            image: 'assets/images/pie.svg'
          },
          {
            identity: GraphType.SEMI_CIRCLE_PIE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Semi Circle Pie',
            image: 'assets/images/semi-circle-pie.svg'
          },
          {
            identity: GraphType.DONUT_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Donut',
            image: 'assets/images/donut.svg'
          },
          {
            identity: GraphType.PYRAMID_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Pyramid',
            image: 'assets/images/pyramid.svg'
          },
          {
            identity: GraphType.BAR_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Bar',
            image: 'assets/images/bar.svg'
          },
          {
            identity: GraphType.COLUMN_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Column',
            image: 'assets/images/column.svg'
          },
          {
            identity: GraphType.CURVED_COLUMN_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Curved Column',
            image: 'assets/images/curved-column.svg'
          },
          {
            identity: GraphType.SMOOTHED_LINE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Smoothed Line',
            image: 'assets/images/smoothed-line.svg'
          },
          {
            identity: GraphType.STEP_LINE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Step line',
            image: 'assets/images/step-line.svg'
          },
          // {
          //   identity: GraphType.THREE_D_PIE_CHART,
          //   graph_type: GraphCategory.SINGLE_Y_AXIS,
          //   type: 0,
          //   label: '3D-Pie',
          //   image: 'assets/images/3d-pie.svg'
          // },
          // {
          //   identity: GraphType.THREE_D_BAR_CHART,
          //   graph_type: GraphCategory.SINGLE_Y_AXIS,
          //   type: 0,
          //   label: '3D-Bar',
          //   image: 'assets/images/3d-bar.svg'
          // },
          // {
          //   identity: GraphType.THREE_D_COLUMN_CHART,
          //   graph_type: GraphCategory.SINGLE_Y_AXIS,
          //   type: 0,
          //   label: '3D-Column',
          //   image: 'assets/images/3d-column.svg'
          // },
          // {
          //   identity: GraphType.THREE_D_CYLINDER_CHART,
          //   graph_type: GraphCategory.SINGLE_Y_AXIS,
          //   type: 0,
          //   label: '3D-Cylinder',
          //   image: 'assets/images/3d-cylinder.svg'
          // },
          {
            identity: GraphType.FUNNEL_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Funnel',
            image: 'assets/images/funnel.svg'
          },
          {
            identity: GraphType.LOLLIPOP_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Lollipop',
            image: 'assets/images/lollipop.svg'
          },
          {
            identity: GraphType.DRAGGABLE_PIE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Draggable Pie',
            image: 'assets/images/draggable-pie.svg'
          },
          {
            identity: GraphType.SPIRAL_BAR_TIMELINE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Spiral Bar Timeline',
            image: 'assets/images/spiral-bar-timeline.svg'
          },
          {
            identity: GraphType.SPIRAL_TIMELINE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Spiral Timeline',
            image: 'assets/images/spiral-timeline.svg'
          },
          {
            identity: GraphType.FISHBONE_TIMELINE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Fishbone',
            image: 'assets/images/fishbone.svg'
          },
          {
            identity: GraphType.SERPENTINE_TIMELINE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Serpentine Timeline',
            image: 'assets/images/serpentine-timeline.svg'
          },
          {
            identity: GraphType.ROAD_TIMELINE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Road Timeline',
            image: 'assets/images/road-timeline.svg'
          },
          {
            identity: GraphType.LINEAR_TIMELINE_CHART,
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 0,
            label: 'Linear Timeline',
            image: 'assets/images/linear-timeline.svg'
          }
        ]
      }
    ]; */


    this.allGraphItems = this._commonService.getAllGraphItems;
    this.prepareGraphDropDown();


    this.tableExportItems.push({
      //label: 'Table Export',
      exportType: this.actionType,
      items: [
        { label: 'Export to Excel', icon: 'pi pi-file-excel', type: 'excel' , image:'export-excel-icon.svg'},
        { label: 'Export to Google Sheets', icon: 'pi pi-google', type: 'google_sheet', image:'export-google-icon.svg' },
        { label: 'Export to CSV', icon: 'pi pi-file-csv', type: 'csv', image:'export-csv-icon.svg' },
        { label: 'Email This Report', icon: 'pi pi-envelope', type: 'email', image:'export-emailreport-icon.svg' },
        { label: 'Schedule This Report', icon: 'pi pi-calendar', type: 'schedule', image:'clock-16.svg' },
      ]
    });
    this.graphExportItems.push({
      label: 'Image',
      exportType: this.actionType,
      items: [
        { label: 'PNG', icon: 'pi pi-file-excel', type: 'png', image:'export-png-icon.svg', class:'Image', styleClass: 'export-image-item' },
        { label: 'PDF', icon: 'pi pi-google', type: 'pdf', image:'export-pdf-icon.svg', class:'Image', styleClass: 'export-image-item' },
        { label: 'SVG', icon: 'pi pi-file-csv', type: 'svg', image:'export-svg-icon.svg', class:'Image', styleClass: 'export-image-item' },
        { label: 'JPEG', icon: 'pi pi-file-csv', type: 'jpg', image:'export-jpg-icon.svg', styleClass: 'export-image-item' },
      ]
    });
    this.graphExportItems.push({
      label: 'Data',
      exportType: this.actionType,
      items: [
        { label: 'JSON', icon: 'pi pi-file-excel', type: 'json', image:'export-json-icon.svg', styleClass: 'export-data-item' },
        { label: 'CSV', icon: 'pi pi-google', type: 'csv', image:'export-csv-icon.svg', styleClass: 'export-data-item' },
        { label: 'XLSX', icon: 'pi pi-file-csv', type: 'xlsx', image:'export-xlsx-icon.svg', styleClass: 'export-data-item' },
        { label: 'HTML', icon: 'pi pi-file-csv', type: 'html', image:'export-html-icon.svg', styleClass: 'export-data-item' },
      ]
    });
    this.graphExportItems.push({
      label: 'Print',
      exportType: this.actionType,
      items: [
        { label: 'Print', icon: 'pi pi-file-excel', type: 'print', image:'print-icon.svg', styleClass: 'export-print-item' },
      ]
    });
    
    this.itemsSetting = [
      { label: 'Mobile Report', icon: 'pi pi-mobile', type: 'mobile' , image:'mobile-icon.svg' },
      { label: 'Generate API', icon: 'pi pi-file-js', type: 'custom_api' , image:'generateAPI-icon.svg' },
    ];

  }

  /**
   * This method is used to prepare the grophs drop down data
   * @auth chari on 18-07-2025
   */
  prepareGraphDropDown() {
    //doing the deep copy
    this.defaultGraphItems = this.allGraphItems.map(item => ({
      ...item,
      items: item.items ? item.items.map((subItem: any) => ({ ...subItem })) : []
    }));
    if (this.isMultiLineGraph) {
      this.graphItems = [...this.defaultGraphItems.map((x) => {
        x.items = [...(x.items || []).filter((y: any) => y['graph_type'] == GraphCategory.MULTI_GRAPH)];
        return x;
      })];
    } else {
      // Respect previous Show More / Show Less state when reopening menu or after report load
      if (this.isGraphMenuExpanded) {
        this.graphItems = [...this.defaultGraphItems.map((x) => {
          x.items = [...(x.items || []), {
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 2,
            label: 'Show Less',
            image: '',
            styleClass: "p-menu-show-more-btn",
          }];
          return x;
        })];
      } else {
        this.graphItems = [...this.defaultGraphItems.map((x) => {
          x.items = [...(x.items || []).filter((y, index) => (index < 6)), {
            graph_type: GraphCategory.SINGLE_Y_AXIS,
            type: 1,
            label: 'Show More',
            image: '',
            styleClass: "p-menu-show-more-btn",
          }];
          return x;
        })];
      }
    }
  }

  /**
   * This click on the show more /less more graphs 
   * @param event current item
   * @param type it's 0,1 1 for show more and 0 for show less.
   */
  onShowMoreClick(event: MouseEvent, type: number) {
    event.preventDefault();
    event.stopPropagation();
    if (type == 1) {
      this.isGraphMenuExpanded = true;
      this.defaultGraphItems = this.allGraphItems.map(item => ({
        ...item,
        items: item.items ? item.items.map((subItem: any) => ({ ...subItem })) : []
      }));
      this.graphItems = [...this.defaultGraphItems.map((x) => {
        x.items = [...(x.items || []), {
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 2,
          label: 'Show Less',
          image: '',
          styleClass: "p-menu-show-more-btn",
        }];
        return x;
      })];
    } else {
      this.isGraphMenuExpanded = false;
      this.graphItems = [...this.defaultGraphItems.map((x) => {
        x.items = [...(x.items || [])].slice(0, -1);
        x.items = [...(x.items || []).filter((y, index) => (index < 6)), {
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 1,
          label: 'Show More',
          image: '',
          styleClass: "p-menu-show-more-btn",
        }];
        return x;
      })];
    }
  }
  /**
   * 
   * @param event This method is used to show the graph menu
   * @author chari on 22-07-2025
   */
  onReportMenuClick(event: Event) {
    this.prepareGraphDropDown();
    this.reportMenu.toggle(event);
  }

  /**
   * This method is used to change the graph type 
   * @param graphItem current graph item
   * @author chari on 22-07-2025
   */
  activateGraph(graphItem: GraphItem) {
    this.applySelectedGraphType(graphItem.identity);

    // Emit the current report data to trigger graph updates
    if (this.reportData && this.reportData.length > 0) {
      this._commonService.updateGraphReportState(this.buildGraphReportStateConfig(this.reportData));
    }
  }

  /**
   * Applies the selected/default graph type to the menu and render state.
   * Uses reportFormData.defaultGraphType when available so fresh generate
   * does not fall back to Line after navigation (Subject does not replay).
   */
  private applySelectedGraphType(graphType?: GraphType | string | null): void {
    const resolvedGraphType = (graphType || this.reportFormData?.defaultGraphType || this.selectedGraphItem || GraphType.LINE_CHART) as GraphType;
    const shouldSyncService = this.currentDefaultGraphType !== resolvedGraphType;
    this.selectedGraphItem = resolvedGraphType;
    this.currentDefaultGraphType = resolvedGraphType;
    if (shouldSyncService) {
      this._commonService.defaultGraphType = resolvedGraphType;
    }

    if (!this.allGraphItems?.length) {
      return;
    }

    this.graphItems = this.allGraphItems.map(item => ({
      ...item,
      items: item.items ? item.items.map((subItem: any) => {
        subItem.class = (resolvedGraphType === subItem.identity) ? 'active' : '';
        return { ...subItem };
      }) : []
    }));
  }

  /**
   * Helper method to check if a graph type is a multi-graph type
   * @param graphType - The graph type to check
   * @returns True if it's a multi-graph type
   */
  isMultiGraphType(graphType: GraphType): boolean {
    return graphType === GraphType.LINE_CHART ||
      graphType === GraphType.STACKED_COLUMN_CHART ||
      graphType === GraphType.STACKED_AREA_CHART ||
      graphType === GraphType.RANGE_AREA_CHART ||
      graphType === GraphType.NESTED_DONUT_CHART ||
      graphType === GraphType.CLUSTERED_COLUMN_CHART;
  }

  /**
   * Helper method to get graph type display name
   * @param graphType - The graph type
   * @returns Display name for the graph type
   */
  getGraphTypeDisplayName(graphType: GraphType): string {
    const graphItem = this.allGraphItems[0]?.items?.find(item => item['identity'] === graphType);
    return graphItem?.label || graphType;
  }

  /**
   * Helper method to validate if a string is a valid graph type
   * @param value - The string to validate
   * @returns True if valid graph type
   */
  validateGraphType(value: string): boolean {
    return isValidGraphType(value);
  }

  /**
   * Graph reports use only the first group-by column (X-Axis).
   */
  private getGraphGroupByFilters(): (string | number)[] {
    const reportFormData = this.reportFormData;
    if (!reportFormData) {
      return [];
    }

    const groupByFilters = reportFormData.groupByFilters;
    if (Array.isArray(groupByFilters) && groupByFilters.length > 0) {
      return [groupByFilters[0]];
    }

    const groupByLevel = reportFormData.groupByLevel ?? 0;
    if (
      reportFormData.reportType === ReportType.DETAILED_REPORT &&
      groupByLevel > 0 &&
      Array.isArray(reportFormData.columns) &&
      reportFormData.columns.length > 0
    ) {
      return [reportFormData.columns[0]];
    }

    return [];
  }

  private buildGraphReportStateConfig(reportData: any): any {
    return {
      ReportType: ReportType,
      reportFormData: {
        ...this.reportFormData,
        groupByFilters: this.getGraphGroupByFilters()
      },
      reportData,
      allColumnsData: this.allColumnsData,
      getColumnInfo: this.getColumnInfo.bind(this)
    };
  }

  /**
   * This method is used to toggle the table and the graph
   * @param type it holds the 1 for table and 2 for graph
   */
  async toggleGraphAndTable(type: number) {
    this.isGraphReport = (type == 2) ? 1 : 0;
    this.actionType = type;
    if (type == 2) {
      await this.getReportData();
    }
  }

  async getSavedReportData(savedReport: any = {}) {
    if (Object.keys(savedReport).length > 0) {
      this._commonService.formLoaded = false;
      this.moduleId = savedReport.id;
      this.reportId = savedReport.reportId;
      this.loadedSavedReportData = false;
      this.savedReportData = {};
      this.reportConfig = {};
      this.reportFormData = {};
      await this.patchDynamicSavedReportData(savedReport);
      this.isInitialLoad = true;
      await this.getReportData();
    }
  }

  patchDynamicSavedReportData(savedReport: any = {}): Promise<void> {
    //console.log('calling patchDynamicSavedReportData', savedReport);
    if (this.moduleId != 0 && this.reportId != 0 && Object.keys(this.savedReportData).length === 0 && Object.keys(this.reportConfig).length === 0) {
      this._commonHttpService.getSavedReportData({ reportId: this.reportId }).subscribe((data: any) => {
        this.setSavedReportData(data, savedReport).then(() => {
          if (Object.keys(savedReport).length > 0) {
            //this.getReportData();
          }
        });
      });
    } else if (this.moduleId != 0 && this.reportId == 0 && Object.keys(this.reportConfig).length === 0) {
      this.executeSequentially().then(() => {
        if (Object.keys(savedReport).length > 0) {
          //this.getReportData();
        }
      });
    } else {
      this.setAllColumnsData().then(() => {
        this.checkDataLoaded();
        if (this.reportFormData.reportType == ReportType.GRAPH_REPORT) {
          this.applySelectedGraphType(this.reportFormData.defaultGraphType);
          this.toggleGraphAndTable(2);
        }
        if (Object.keys(savedReport).length > 0) {
          //this.getReportData();
        } else {
          //this.getReportData();
        }
      });
    }
    return Promise.resolve();
  }


  async setSavedReportData(data: any, savedReport: any = {}): Promise<void> {
    this.savedReportData = data;
    if (Object.keys(this.savedReportData).length > 0) {
      this.loadedSavedReportData = true;
    }
    // Execute functions sequentially
    await this.executeSequentially();
    console.log('calling checkDataLoaded');
    this.checkDataLoaded();
    console.log('calling getReportData');
    console.log('savedReport', savedReport);
    if (Object.keys(savedReport).length > 0) {
      await this.getReportData();
    }
    return Promise.resolve();
  }

  private async executeSequentially() {
    try {
      this.getReportPostData = {};
      this.columnLevelOptions = {};
      await this.getUserConfig();
      await this.getReportConfig();
      await this.setAllColumnsData();
      await this.getDimensionColumnsData();
      await this.setReportFormData();
      if (Object.keys(this.reportFormData).length > 0) {
        // Set default dateFilterCol and periodValue for existing report data
        await this.setDefaultDateFilterValues();
      } else {
        await this.setBasicReportFormData({
          reportId: Number(this.moduleId),
          reportName: this.reportConfig.reportName,
          reportDesc: this.reportConfig.reportName,
          periodValue: 6,
          isSummarized: (this.reportConfig.isDefaultSummarized == 0 || this.reportConfig.isDefaultSummarized == 1) ? this.ReportType.DETAILED_REPORT : this.ReportType.SUMMARY_REPORT,
          businessUnitId: this.userConfig.userBusinessUnitDetails.visibleBusinessUnitList.join(','),
        }, this.getDefaultColumns(), this.getDefaultGroupByFilters());
        await this.setDependentReportFormData(this.reportFormData);
        // Set default dateFilterCol and periodValue for new report data
        await this.setDefaultDateFilterValues();
        this.checkDataLoaded();
      }
      await this.applyStagesToReportFormData();
    } catch (error: any) {
      // Error handling without console
    }
  }

  /**
   * Set default dateFilterCol and periodValue values
   */
  async setDefaultDateFilterValues() : Promise<void> {
    // Set default periodValue if not already set
    if (!this.reportFormData.periodValue) {
      this.reportFormData.periodValue = 6; // Default to 30 days
    }

    // Set default dateFilterCol if not already set (backend expects a number, never "")
    if (this.reportFormData.dateFilterCol === '' || this.reportFormData.dateFilterCol == null) {
      // Find first date type column from allColumnsData
      const dateTypeColumn = Object.values(this.allColumnsData).find((column: any) => column.searchType == 2) as any;
      this.reportFormData.dateFilterCol = dateTypeColumn ? dateTypeColumn.id : 0;
    }
    return Promise.resolve();
  }

  /**
   * Backend accepts only numeric dateFilterCol (0 when none). Never send "".
   */
  private normalizeDateFilterCol(value: any): number | string {
    if (value === '' || value === null || value === undefined) {
      return 0;
    }
    return value;
  }

  getDefaultColumns(): any[] {
    let isSummarized = (this.reportConfig.isDefaultSummarized == 0 || this.reportConfig.isDefaultSummarized == 1) ? this.ReportType.DETAILED_REPORT : this.ReportType.SUMMARY_REPORT;
    return Object.values(this.allColumnsData).filter((column: any) => ((isSummarized == this.ReportType.SUMMARY_REPORT && column.forGroupBy == 2) || (isSummarized == this.ReportType.DETAILED_REPORT))).map((column: any) => { return column.id }).slice(0, 20);
  }

  getDefaultGroupByFilters(): any[] {
    let isSummarized = (this.reportConfig.isDefaultSummarized == 0 || this.reportConfig.isDefaultSummarized == 1) ? this.ReportType.DETAILED_REPORT : this.ReportType.SUMMARY_REPORT;
    return Object.values(this.allColumnsData).filter((column: any) => ((isSummarized == this.ReportType.SUMMARY_REPORT && column.forGroupBy == 1))).map((column: any) => { return column.id }).slice(0, 1);
  }

  getUserConfig(): Promise<void> {
    return new Promise((resolve) => {
      if (Object.keys(this.userConfig).length === 0) {
        this._commonHttpService.getUserConfig().subscribe((userConfig: any) => {
          this.userConfig = userConfig;
          //is.setAllColumnsData();
          this.checkDataLoaded();
          resolve();
        });
      } else {
        this.checkDataLoaded();
        //this.setAllColumnsData();
        resolve();
      }
    });
  }

  setAllColumnsData(): Promise<void> {
    let savedColumns: any[] = [];
    let isAdminReport = 0;
    return new Promise((resolve) => {
      if (Object.keys(this.savedReportData).length > 0) {
        const isDimensionReport = this.savedReportData.savedReports[0].dimensionReport;
        isAdminReport = this.savedReportData.savedReports[0].isAdminReport;
        savedColumns = this.savedReportData.savedReports[0].savedReportColumns.reduce((acc: any, column: any) => {
          let tempColumnId = column.columnId;
          if (column.isCustomField == 1 && column.columnId.toString().indexOf('c') == -1) {
            tempColumnId = 'c' + column.columnId;
            column.columnName = column.columnName;
          }
          if (column.isDimensionColumn == 1 && column.columnId.toString().indexOf('d') == -1) {
            tempColumnId = 'd' + column.columnId;
            column.columnName = column.columnName;
          }
          column.columnId = tempColumnId;
          acc[tempColumnId] = column;
          return acc;
        }, {} as Record<string, any>);
      }
      //console.log('savedColumns', savedColumns);
      this.allColumnsData = this.reportConfig.reportColumns.reduce((acc: any, column: any) => {
        if (savedColumns[column.id] && isAdminReport == 0) {
          column.columnName = savedColumns[column.id].columnName;
        }
        acc[column.id] = column;
        return acc;
      }, {} as Record<string, any>);
      this.reportConfig.customFields.forEach((item: any) => {
        if (savedColumns[item.id] && isAdminReport == 0) {
          item.columnName = savedColumns[item.id].columnName;
        }
        this.allColumnsData[item.id] = {
          id: item.id,
          columnName: item.columnName,
          colDataType: item.colDataType,
          searchType: item.searchType,
          existingRecordId: item.existingRecordId,
          listViewFlag: item.listViewFlag,
          forGroupBy: item.forGroupBy,
          forMainFilter: item.forMainFilter,
          customField: item.customField,
          description: item.description || '',
        };
      });
      this.clearColumnLookupCaches();
      resolve();
    });
  }

  getReportConfig(): Promise<void> {
    return new Promise((resolve) => {
      let reportId = this.moduleId;
      let reportType = this.reportConfig.reportType;
      if (Object.keys(this.savedReportData).length > 0) {
        reportId = this.savedReportData.savedReports[0].reportId;
        reportType = this.savedReportData.savedReports[0].isSummarized;
      }
      this._commonHttpService.getReportConfig({
        reportId: reportId,
        reportType: reportType
      }).subscribe(async (data: any) => {
        this.reportConfig = data;
        // After get-report-config: load stage columns for report 109/110
        if (Number(reportId) === 109 || Number(reportId) === 110) {
          await this.getConversionRatioFields(Number(reportId));
        }
        // Load users list for report 110 only
        if (Number(reportId) === 110) {
          await this.getUsersListOptions();
        }
        this.checkDataLoaded();
        resolve();
      });
    });
  }

  async getConversionRatioFields(reportId: number = 109): Promise<boolean> {
    if (Number(reportId) !== 109 && Number(reportId) !== 110) {
      return false;
    }

    // Already loaded — do not call API again
    if (this.stages?.length) {
      return true;
    }

    // Reuse in-flight request so concurrent callers don't trigger multiple APIs
    if (this.conversionRatioFieldsPromise) {
      return this.conversionRatioFieldsPromise;
    }

    this.conversionRatioFieldsPromise = new Promise<boolean>((resolve) => {
      this._commonHttpService.getConversionRatioField().subscribe({
        next: (response: any) => {
          const options = Array.isArray(response)
            ? response
            : Array.isArray(response?.data)
              ? response.data
              : Array.isArray(response?.options)
                ? response.options
                : [];
          this.stages = options
            .filter((item: any) => item?.code != null && item?.name != null)
            .map((item: any) => ({ code: item.code, name: item.name }));
          resolve(true);
        },
        error: () => {
          this.stages = [];
          this.conversionRatioFieldsPromise = null;
          resolve(false);
        }
      });
    });

    return this.conversionRatioFieldsPromise;
  }

  async getUsersListOptions(businessUnitIdsParam?: any[]): Promise<boolean> {
    const reportId = Number(this.reportFormData?.reportId || this.moduleId);
    if (reportId !== 110) {
      return false;
    }

    // Already loaded — do not call API again
    if (this.usersListOptions?.length) {
      return true;
    }

    // Reuse in-flight request so concurrent callers don't trigger multiple APIs
    if (this.usersListPromise) {
      return this.usersListPromise;
    }

    const normalizeBusinessUnitIds = (ids: any[]): any[] => {
      if (!Array.isArray(ids) || ids.length === 0) {
        return [];
      }
      return ids
        .map((id: any) => (id != null && typeof id === 'object' ? id.code : id))
        .filter((id: any) => id != null && id !== '' && !isNaN(Number(id)));
    };

    const businessUnitIds = normalizeBusinessUnitIds(
      Array.isArray(businessUnitIdsParam) && businessUnitIdsParam.length > 0
        ? businessUnitIdsParam
        : (Array.isArray(this.reportFormData?.businessUnitIds) && this.reportFormData.businessUnitIds.length > 0
          ? this.reportFormData.businessUnitIds
          : (this.userConfig?.userBusinessUnitDetails?.visibleBusinessUnitList || []))
    );

    if (!businessUnitIds?.length) {
      this.usersListOptions = [];
      return false;
    }

    this.usersListPromise = new Promise<boolean>((resolve) => {
      this._commonHttpService.getUsersList(businessUnitIds).subscribe({
        next: (response: any) => {
          const options = Array.isArray(response)
            ? response
            : Array.isArray(response?.data)
              ? response.data
              : [];
          this.usersListOptions = options
            .filter((item: any) => item?.code != null && item?.name != null)
            .map((item: any) => ({ code: item.code, name: item.name }));
          this.usersListPromise = null;
          resolve(true);
        },
        error: () => {
          this.usersListOptions = [];
          this.usersListPromise = null;
          resolve(false);
        }
      });
    });

    return this.usersListPromise;
  }

  private async applyStagesToReportFormData(): Promise<void> {
    const reportId = Number(this.reportFormData?.reportId || this.moduleId);
    if (reportId !== 109 && reportId !== 110) {
      return;
    }

    if (!this.stages?.length) {
      await this.getConversionRatioFields(reportId);
    }

    if (Array.isArray(this.reportFormData.stages) && this.reportFormData.stages.length > 0) {
      // Keep exploded order; map to option codes so multiselect selection matches
      this.reportFormData.stages = this.reportFormData.stages
        .map((code: any) => this.stages.find((stage) => String(stage.code) === String(code))?.code)
        .filter((code: any) => code != null);
    }

    if (!this.reportFormData.stages?.length) {
      this.reportFormData.stages = this.stages.slice(0, 10).map((stage) => stage.code);
    }

    if (reportId === 110) {
      if (!this.usersListOptions?.length) {
        await this.getUsersListOptions();
      }
      if (Array.isArray(this.reportFormData.usersList) && this.reportFormData.usersList.length > 0) {
        this.reportFormData.usersList = this.reportFormData.usersList
          .map((code: any) => this.usersListOptions.find((user) => String(user.code) === String(code))?.code)
          .filter((code: any) => code != null);
      }
      if (!this.reportFormData.usersList?.length) {
        this.reportFormData.usersList = this.usersListOptions.slice(0, 10).map((user) => user.code);
      }
    }
  }

  getModuleInfo(moduleId: number) {
    return this.reportConfig.reportModules.find((module: any) => module.id == moduleId);
  }

  private clearColumnLookupCaches(): void {
    this.columnInfoCache.clear();
    this.unifiedTableColumnsCache = [];
    this.unifiedTableColumnsCacheKey = '';
  }

  private rebuildDimensionColumnLookup(options: any[] = this.dimensionColumnsOptions): void {
    this.dimensionColumnLookup = {};
    (options || []).forEach((column: any) => {
      if (column?.code != null) {
        this.dimensionColumnLookup[String(column.code)] = column;
      }
    });
    this.clearColumnLookupCaches();
  }

  getColumnInfo(columnId: any) {
    if (columnId === null || columnId === undefined || columnId === '') {
      return null;
    }

    const cacheKey = String(columnId);
    if (this.columnInfoCache.has(cacheKey)) {
      return this.columnInfoCache.get(cacheKey);
    }

    let columnInfo: any = null;

    // Dimension columns (ids like d59999) — cache the resolved object so CD does not recreate it
    if (
      typeof columnId === 'string' &&
      columnId.startsWith('d') &&
      this.reportFormData.reportType == ReportType.DIMENSION_REPORT
    ) {
      const tempColInfo = this.getDimensionColumnInfo(columnId);
      if (tempColInfo) {
        columnInfo = {
          columnName: tempColInfo.name,
          columnId: tempColInfo.code,
          colDataType: '1',
          description: tempColInfo.description || ''
        };
      }
    } else if (this.allColumnsData && columnId) {
      columnInfo = this.allColumnsData[columnId] || null;
    }

    this.columnInfoCache.set(cacheKey, columnInfo);
    return columnInfo;
  }

  getColumnDescription(columnId: any): string {
    const description = this.getColumnInfo(columnId)?.description;
    return typeof description === 'string' ? description.trim() : '';
  }

  getDimensionColumnInfo(columnId: string) {
    if (!columnId) {
      return null;
    }
    if (Object.keys(this.dimensionColumnLookup).length > 0) {
      return this.dimensionColumnLookup[String(columnId)] || null;
    }
    if (!this.dimensionColumnsOptions || !Array.isArray(this.dimensionColumnsOptions)) {
      return null;
    }
    return this.dimensionColumnsOptions.find((column: { name: string, code: string }) => column.code == columnId) || null;
  }

  /**
   * Builds predefined filters based on saved filter IDs
   */
  private buildPreDefinedFilters(tempPreDefFilterIds: number[]): (number | null)[][] {
    return this.reportConfig.reportFilters.map((filter: any) =>
      tempPreDefFilterIds.includes(filter.id) ? [filter.id] : []
    );
  }

  /**
   * Transforms saved report filters into the required filter format
   */
  private parseValidDate(value: any): Date | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return toCalendarDate(value);
  }

  private async transformSavedFilters(savedReportFilters: any[]): Promise<any[]> {
    return Promise.all(savedReportFilters.map(async (filter: any, index: number) => {

      const filterCondition = `filterCondition${index}`;
      if (filter.value = filter.filterValue) {
        delete filter.filterValue;
      }

      let options: any[] = [];
      let filterSeachType = this.getColumnInfo(filter.columnId).searchType || 0;
      if (filterSeachType == 4) {
        if (filter.filterType == 15 || filter.filterType == 16)
          filter.value = filter.value.split(',').map((item: string) => item.trim());
        else
          filter.value = filter.value.toString();

        console.log('calling getFilterOptions', filter.value.toString());
        options = await this.getFilterOptions(filter);
      }

      const filterTypeNum = Number(filter.filterType);
      if (![13, 14].includes(filterTypeNum) && filterSeachType == 2) {
        const parsed = this.parseValidDate(filter.startDate);
        if (parsed) {
          filter.value = parsed;
        }
      }
      if ([13, 14].includes(filterTypeNum) && filterSeachType == 2) {
        const parsedStart = this.parseValidDate(filter.startDate);
        const parsedEnd = this.parseValidDate(filter.endDate);
        if (parsedStart) {
          filter.startDate = parsedStart;
        }
        if (parsedEnd) {
          filter.endDate = parsedEnd;
        }
      }

      return {
        id: filter.id,
        columnId: filter.columnId,
        searchType: filter.filterType,
        dataType: filter.filterType as ValidDataType,
        value: filter.value,
        options: options,
        startDate: filter.startDate,
        endDate: filter.endDate,
        [filterCondition]: filter.filterAndOrCondition === '' ? 'AND' : filter.filterAndOrCondition
      };
    }));
  }

  async getFilterOptions(filter: any): Promise<any[]> {
    return new Promise((resolve) => {
      this._commonHttpService.makeFilterDropDowns(this.buildFilterDropdownPayload(filter.columnId, {}, false)).subscribe((res: any) => {
        if (res.status == 1) {
          resolve(res.options);
        } else {
          resolve([]);
        }
      });
    });
  }

  /**
   * Column-header dropdowns pass the current filters. Left-side filter dropdowns
   * do not: they only need reportId, columnId, and the report criteria.
   */
  private buildFilterDropdownPayload(columnId: any, extra: Record<string, any> = {}, includeFilters: boolean = true): any {
    const posted = this.getReportPostData?.reportId
      && String(this.getReportPostData.reportId) === String(this.reportFormData?.reportId || this.moduleId)
      ? this.getReportPostData
      : null;
    const base = posted ? this.stripReportPaging(posted) : this.buildReportQueryFromForm();
    const filterType = (this.reportFormData?.filterType != null && this.reportFormData.filterType !== '')
      ? this.reportFormData.filterType
      : ((base.filterType != null && base.filterType !== '') ? base.filterType : 1);
    const reportId = [this.reportFormData?.reportId, base.reportId, this.getReportPostData?.reportId, this.moduleId, this.reportConfig?.id]
      .find((value) => value !== undefined && value !== null && value !== '');

    const payload: any = {
      ...base,
      columnId: columnId != null ? String(columnId) : base.columnId,
      businessUnitIds: this.reportFormData?.businessUnitIds ?? base.businessUnitIds,
      filterType,
      preDefFilterIds: posted
        ? (base.preDefFilterIds || [])
        : this.collectPreDefFilterIds(this.reportFormData?.preDefinedFilters),
      ...extra,
      reportId,
    };

    if (includeFilters) {
      payload.filters = this.mapFiltersForDropdown(base.filters || []);
      payload.loadAllOption = false;
    } else {
      delete payload.filters;
      payload.loadAllOption = true;
    }

    return payload;
  }

  private stripReportPaging(data: any): any {
    const clone = { ...(data || {}) };
    delete clone.first;
    delete clone.rows;
    delete clone.exportType;
    delete clone.getChartData;
    delete clone.recordsTotal;
    return clone;
  }

  private buildReportQueryFromForm(): any {
    const form = this.reportFormData || {};
    const query: any = {
      reportId: form.reportId,
      businessUnitIds: form.businessUnitIds,
      reportType: form.reportType,
      dateFilterCol: this.normalizeDateFilterCol(form.dateFilterCol),
      periodValue: form.periodValue,
      preDefFilterIds: this.collectPreDefFilterIds(form.preDefinedFilters),
      filters: form.filters || [],
      columnsList: form.columns,
      groupByColumnsList: form.groupByFilters,
      groupByLevel: form.groupByLevel,
      dimensionColumnId: form.dimensionColumnId,
      userReportId: this.reportId || form.userReportId,
      isAdminReport: form.isAdminReport,
      enableHierarchySecurity: form.enableHierarchySecurity ?? false,
    };
    if (Number(form.periodValue) === 10) {
      query.custStartDate = this.formatQueryDate(form.custStartDate);
      query.custEndDate = this.formatQueryDate(form.custEndDate);
    }
    const formRecord = form as Record<string, any>;
    [
      'filterRole', 'roleUserIds', 'teamList', 'teamMembersList',
      'placementReportOn', 'currencyDetails', 'currencyConversion', 'instanceType',
      'marketingStatus', 'benchStatus', 'benchSubStatus', 'includePipelines',
      'stages', 'usersList'
    ].forEach((key) => {
      if (formRecord[key] !== undefined) {
        query[key] = formRecord[key];
      }
    });
    return query;
  }

  private collectPreDefFilterIds(preDefinedFilters: any): number[] {
    const ids: number[] = [];
    if (!preDefinedFilters) {
      return ids;
    }
    preDefinedFilters.forEach((filter: any) => {
      if (filter && filter[0]) {
        ids.push(filter[0]);
      }
    });
    return ids;
  }

  private mapFiltersForDropdown(filters: any[] = []): any[] {
    return (filters || []).map((filter: any, index: number) => {
      const columnInfo = this.getColumnInfo(filter.columnId);
      const dataType = filter.dataType ?? filter.filterType;
      const isDateColumn = columnInfo?.searchType == 2;
      const isDateRange = [13, 14].includes(Number(dataType));
      let value = filter.value ?? filter.filterValue;
      let startDate = filter.startDate;
      let endDate = filter.endDate;

      if (typeof value === 'string' && [15, 16].includes(Number(dataType))) {
        value = value.split(',').map((item: string) => item.trim());
      }
      if (isDateColumn) {
        if (isDateRange) {
          startDate = this.formatQueryDate(startDate);
          endDate = this.formatQueryDate(endDate);
        } else if (value) {
          value = this.formatQueryDate(value);
        }
      }

      const conditionKey = 'filterCondition' + index;
      return {
        id: filter.id ?? null,
        columnId: filter.columnId,
        searchType: columnInfo?.searchType || filter.searchType,
        dataType,
        value,
        startDate: startDate || '',
        endDate: endDate || '',
        condition: filter.condition || filter[conditionKey] || filter.filterAndOrCondition || 'AND'
      };
    });
  }

  private formatQueryDate(value: any): any {
    if (value == null || value === '') {
      return value;
    }
    if (value instanceof Date && !isNaN(value.getTime())) {
      return this.timezoneTransformPipe.transform(value, 'yyyy-MM-dd', this.loggedInUserTimeZone);
    }
    return value;
  }

  getAccessibleBusinessUnitList(tempReportFormData: any) {
    //console.log('reportFormData 1013', tempReportFormData.reportId);
    if (tempReportFormData.reportId == 20) {
      //console.log('globalBusinessUnitList', this.userConfig.userBusinessUnitDetails.globalBusinessUnitList);
      //console.log('indiaBusinessUnitList', this.userConfig.userBusinessUnitDetails.indiaBusinessUnitIds);
      if (Number(tempReportFormData.instanceType) == 1) {
        return [...this.userConfig.userBusinessUnitDetails.globalBusinessUnitList];
      } else {
        return [...this.userConfig.userBusinessUnitDetails.indiaBusinessUnitList];
      }
    }
    return [...this.userConfig.userBusinessUnitDetails.accessibleBusinessUnitList, { name: 'Organization', code: '0' }];
  }

  /**
   * Sets basic report form data properties
   */
  private setBasicReportFormData(tempReportFormData: any, columns: (string | number)[], groupByFilters: (string | number)[]): Promise<void> {
    const accessibleBusinessUnits = this.getAccessibleBusinessUnitList(tempReportFormData);
    const savedBusinessUnitIds = (tempReportFormData.isAdminReport == 1)
      ? [this.userConfig.userBusinessUnitDetails.defaultBusinessUnitId]
      : String(tempReportFormData.businessUnitId ?? '').split(',').map((id: string) => id.trim()).filter((id: string) => id !== '');
    this.reportFormData = {
      businessUnitIds: savedBusinessUnitIds
        .map((code: any) => accessibleBusinessUnits.find((businessUnit: any) => String(businessUnit.code) === String(code))?.code)
        .filter((code: any) => code !== undefined && code !== null && code !== ''),
      reportId: tempReportFormData.reportId,
      reportName: tempReportFormData.reportName,
      reportDesc: tempReportFormData.reportDesc,
      reportType: tempReportFormData.isSummarized.toString() as ReportType,
      columns,
      groupByFilters,
      groupByLevel: tempReportFormData.columnGroupLevel ? tempReportFormData.columnGroupLevel : null,
      userReportId: tempReportFormData.userReportId,
      //periodValue: tempReportFormData.periodValue ? tempReportFormData.periodValue : 6
    };
    this.clearColumnLookupCaches();
    //console.log('reportFormData 1044', this.reportFormData);
    return Promise.resolve();
  }

  async setDependentReportFormData(tempReportFormData: any): Promise<void> {
    //console.log('tempReportFormData 1030', tempReportFormData);
    if (this.reportFormData.reportId == 9) {
      await this.getRoleTeamsList().then(() => {
        this.reportFormData.filterType = Number(tempReportFormData.filterType);
        if (this.reportFormData.filterType == this.filterType.ROLE) {
          this.reportFormData.filterRole = tempReportFormData.filterRoles;
          this.reportFormData.roleUserIds = (tempReportFormData.isAdminReport == 1) ? this.getDefaulRoleUserIds(this.reportFormData.filterRole) : tempReportFormData.roleUserIds.split(',');
        } else if (this.reportFormData.filterType == this.filterType.TEAM) {
          this.reportFormData.groupByLevel = (tempReportFormData.columnGroupLevel !== '' && tempReportFormData.columnGroupLevel != null)
            ? tempReportFormData.columnGroupLevel
            : 1;
          this.reportFormData.teamList = (tempReportFormData.isAdminReport == 1) ? this.getDefaulTeamList() : tempReportFormData.teamIds.split(',').map((id: string) => parseInt(id.trim()));
          this.reportFormData.teamMembersList = (tempReportFormData.isAdminReport == 1) ? this.getDefaultTeamMembersList() : tempReportFormData.roleUserIds.split(',').map((id: string) => parseInt(id.trim()));
        }
      });
    }
    else if (this.reportFormData.reportId == 20) {
      // Production can return placementReportOn as a number (3). Local returns a
      // comma-separated string ("3"). Calling .split() on a number throws and
      // aborts the rest of the form patch (market, currency, period, filters).
      const placementReportOn = tempReportFormData.placementReportOn;
      this.reportFormData.placementReportOn = (placementReportOn !== undefined && placementReportOn !== null && placementReportOn !== '')
        ? (Array.isArray(placementReportOn) ? placementReportOn : String(placementReportOn).split(','))
            .map((id: any) => parseInt(String(id).trim(), 10))
            .filter((id: number) => !isNaN(id))
        : [];
      this.reportFormData.currencyDetails = +tempReportFormData.currencyDetails;
      this.reportFormData.currencyConversion = (+tempReportFormData.currencyDetails != 0) ? true : false;
      this.reportFormData.instanceType = Number(tempReportFormData.instanceType);
    } else if (this.reportFormData.reportId == 5) {
      this.reportFormData.marketingStatus = (tempReportFormData.marketingStatus) ? tempReportFormData.marketingStatus.split(',').map((id: string) => parseInt(id.trim())) : [];
      this.reportFormData.benchStatus = (tempReportFormData.benchStatus) ? tempReportFormData.benchStatus.split(',').map((id: string) => parseInt(id.trim())) : [];
      this.reportFormData.benchSubStatus = (tempReportFormData.benchSubStatus) ? tempReportFormData.benchSubStatus.split(',').map((id: string) => parseInt(id.trim())) : [];
    } else if (this.reportFormData.reportId == 6) {
      this.reportFormData.includePipelines = Number(tempReportFormData.includePipelines) === 1 || tempReportFormData.includePipelines === true;
    } else if (this.reportFormData.reportId == 109 || this.reportFormData.reportId == 110) {
      // API returns stageIds/userIds as comma-separated strings — explode and keep order
      const savedStageIds = tempReportFormData.stageIds ?? tempReportFormData.stages;
      if (savedStageIds !== undefined && savedStageIds !== null && savedStageIds !== '') {
        this.reportFormData.stages = Array.isArray(savedStageIds)
          ? savedStageIds.map((stage: any) => String(stage).trim()).filter((stage: string) => stage !== '')
          : String(savedStageIds).split(',').map((stage: string) => stage.trim()).filter((stage: string) => stage !== '');
      } else if (this.stages?.length) {
        this.reportFormData.stages = this.stages.slice(0, 10).map((stage) => stage.code);
      }
      if (this.reportFormData.reportId == 110) {
        const savedUserIds = tempReportFormData.userIds ?? tempReportFormData.usersList;
        if (savedUserIds !== undefined && savedUserIds !== null && savedUserIds !== '') {
          this.reportFormData.usersList = Array.isArray(savedUserIds)
            ? savedUserIds.map((id: any) => Number(id)).filter((id: number) => !isNaN(id))
            : String(savedUserIds).split(',').map((id: string) => parseInt(id.trim(), 10)).filter((id: number) => !isNaN(id));
        } else {
          this.reportFormData.usersList = this.usersListOptions.slice(0, 10).map((user) => user.code);
        }
      }
    } else if ([14, 16, 36].includes(this.reportFormData.reportId || 0)) {
      await this.getRoleTeamsList().then(() => {
        this.reportFormData.groupByLevel = 1;
        this.reportFormData.teamList = (tempReportFormData.isAdminReport == 1 || this.reportId == 0) ? this.getDefaulTeamList() : tempReportFormData.teamIds.split(',').map((id: string) => parseInt(id.trim()));
        this.reportFormData.teamMembersList = (tempReportFormData.isAdminReport == 1 || this.reportId == 0) ? this.getDefaultTeamMembersList() : tempReportFormData.roleUserIds.split(',').map((id: string) => parseInt(id.trim()));
      });
    }
    return Promise.resolve();
  }

  getDefaulRoleUserIds(filterRole: any): any[] {
    const roleData = this.teamsAndRolesResponse.userRestrictionFields[filterRole];
    if (roleData && Array.isArray(roleData)) {
      return roleData.map((user: any) => user.code);
    }
    return [];
  }

  getDefaulTeamList(): any[] {
    return this.teamsAndRolesResponse.teamData.teamNames.map((team: any) => { return team.code });
  }

  getDefaultTeamMembersList(): any[] {
    const teamMembers: any[] = [];

    if (this.reportFormData.teamList && this.reportFormData.teamList.length > 0) {
      this.reportFormData.teamList.forEach((teamId: string) => {
        const teamMembersArray = this.teamsAndRolesResponse.teamData.teamMembers[Number(teamId)];
        if (teamMembersArray && Array.isArray(teamMembersArray)) {
          teamMembersArray.forEach((member: any) => {
            if (teamMembers.filter((item: any) => item == member.code).length == 0) {
              teamMembers.push(member.code);
            }
          });
        }
      });
    }
    return teamMembers;
  }

  getDimensionColumnsData(): Promise<void> {
    this.dimensionColumnsOptions = [];
    this.rebuildDimensionColumnLookup([]);
    if (Object.keys(this.savedReportData).length > 0) {
      const tempReportFormData: any = this.savedReportData.savedReports[0];
      if (tempReportFormData.dimensionColId) {
        return new Promise<void>((resolve) => {
          this._commonHttpService.makeFilterDropDowns(this.buildFilterDropdownPayload(tempReportFormData.dimensionColId, { isDimensionReport: 1, businessUnitIds: tempReportFormData.businessUnitId.split(',') })).subscribe((res: any) => {
            if (res.status == 1) {
              this.dimensionColumnsOptions = res.options;
              this.rebuildDimensionColumnLookup(this.dimensionColumnsOptions);
            }
            resolve();
          });
        });
      }
    }
    return Promise.resolve();
  }

  async setReportFormData() : Promise<void> {
    this.defaultDateFormat = this.userConfig.dateFormat.replace('yyyy', 'yy')
    this.loggedInUserTimeZone = this.userConfig.loggedInUserTimeZone;
    this.defaultTimeZone = this.userConfig.defaultTimeZone;
    this.enableCustomReportApi = this.userConfig.enableCustomReportApi;
    if (Object.keys(this.savedReportData).length > 0) {
      const tempReportFormData: any = { ...this.savedReportData.savedReports[0] };

      // Process columns and group by filters
      const { columns, groupByFilters } = this.savedReportService.processSavedReportColumns(tempReportFormData, false, this.allColumnsData, this.dimensionColumnsOptions);
      /*if (tempReportFormData.reportId == 9) {
        await this.getRoleTeamsList().then(() => {
          // Set basic report form data
          this.setBasicReportFormData(tempReportFormData, columns, groupByFilters);
        });
      } else {
        // Set basic report form data
        await this.setBasicReportFormData(tempReportFormData, columns, groupByFilters);
      }*/
      this.setBasicReportFormData(tempReportFormData, columns, groupByFilters);
      await this.setDependentReportFormData(tempReportFormData);

      // Process saved report filters
      const {
        savedReportFilters,
        sortColumns,
        dateFilterCol,
        periodValue,
        tempPreDefFilterIds,
        recordsPerPage,
        custStartDate,
        custEndDate
      } = this.savedReportService.processSavedReportFilters(tempReportFormData, this.allColumnsData);

      // Build predefined filters
      const preDefinedFilters = this.buildPreDefinedFilters(tempPreDefFilterIds);

      // Available before dropdown options load, so filter-dropdown/generate
      // receives the same filters and predefined filters as get-report.
      this.reportFormData.dateFilterCol = dateFilterCol;
      this.reportFormData.periodValue = periodValue;
      this.reportFormData.custStartDate = custStartDate;
      this.reportFormData.custEndDate = custEndDate;
      this.reportFormData.sortColumns = sortColumns;
      this.reportFormData.groupByFilters = groupByFilters;
      this.reportFormData.preDefinedFilters = preDefinedFilters;
      this.reportFormData.filters = savedReportFilters;

      // Transform saved filters
      const tempFilters = await this.transformSavedFilters(savedReportFilters);

      // Set remaining properties
      this.rows = recordsPerPage;
      this.reportFormData.filters = tempFilters;
      this.reportFormData.reportType = tempReportFormData.isSummarized as ReportType;
      if (tempReportFormData.dimensionReport == 1) {
        this.reportFormData.reportType = ReportType.DIMENSION_REPORT;
        this.reportFormData.dimensionColumnId = tempReportFormData.dimensionColId;
      }
      this.reportFormData.defaultGraphType = tempReportFormData.defaultGraphType;
      this.reportFormData.enableHierarchySecurity = Number(tempReportFormData.enableHierarchySecurity) === 1
        || tempReportFormData.enableHierarchySecurity === true;

      this.reportFormData.userReportId = tempReportFormData.userReportId;
      this.reportFormData.isAdminReport = tempReportFormData.isAdminReport;
    }
    this.checkDataLoaded();
    if (this.reportFormData.reportType == ReportType.GRAPH_REPORT) {
      this.applySelectedGraphType(this.reportFormData.defaultGraphType);
      this.toggleGraphAndTable(2);
    } else{
      this.toggleGraphAndTable(1);
    }
    return Promise.resolve();
  }

  async getRoleTeamsList(): Promise<boolean> {
    let promise = new Promise<boolean>((resolve) => {
      this._commonHttpService.getRoleWiseUsersList(this.reportFormData.businessUnitIds).subscribe((response: TeamsAndRolesResponse) => {
        this.teamsAndRolesResponse = response;
        resolve(true);
      });
    });
    return promise;
  }

  async getTalentBenchReportOptions(): Promise<boolean> {
    let promise = new Promise<boolean>((resolve) => {
      this._commonHttpService.getTalentBenchReportOptions().subscribe((response: TalentBenchReportOptions) => {
        this.talentBenchReportOptions = response;
        resolve(true);
      });
    });
    return promise;
  }

  private checkDataLoaded() {
    // Check if all required data is loaded
    const hasSavedReportData = (this.savedReportData && Object.keys(this.savedReportData).length > 0 || this.reportId == 0);
    const hasReportConfig = this.reportConfig && Object.keys(this.reportConfig).length > 0;
    const hasUserConfig = this.userConfig && Object.keys(this.userConfig).length > 0;
    const hasReportFormData = (this.reportFormData && Object.keys(this.reportFormData).length > 0) ? true : false;

    if (hasSavedReportData && hasReportConfig && hasUserConfig && hasReportFormData) {
      this.isDataLoaded = true;

    }
  }

  ngOnDestroy() {
    // Reset processing flag
    this.isProcessingSavedReportData = false;
    if (this.savedReportDataSubscription) {
      this.savedReportDataSubscription.unsubscribe();
    }
    if (this.defaultGraphTypeSubscription) {
      this.defaultGraphTypeSubscription.unsubscribe();
    }
  }

  setTableHeight() {
    // Adjust 200px as needed for header/footer
    this.tableHeight = (window.innerHeight - 150) + 'px';
    // Table height set
  }

  showGenerateReportForm() {
    if (this.generateReportForm) {
      this.generateReportForm.showAllFormFields();
      this._commonService.showGenerateReportForm();
    }
  }

  showFiltersBlock() {
    if (this.generateReportForm) {
      this.generateReportForm.showFiltersFormFields();
      this._commonService.showGenerateReportForm();
    }
  }

  showColumnsBlock() {
    if (this.generateReportForm) {
      this.generateReportForm.showColumnsFormFields();
      this._commonService.showGenerateReportForm();
    }
  }

  async handleReportData(data: any) {
    // Update form data regardless of action type
    if (data.reportFormData) {
      this.reportFormData = data.reportFormData;
    }

    // Update other data if available
    if (data.reportConfig) {
      this.reportConfig = data.reportConfig;
      
      // Refresh reportConfig dependent data when fresh config is received
      await this.refreshReportConfigData();
    }
    if (data.userConfig) {
      this.userConfig = data.userConfig;
    }
    if (data.teamsAndRolesResponse) {
      this.teamsAndRolesResponse = data.teamsAndRolesResponse;
    }
    if (data.dimensionColumnsOptions) {
      this.dimensionColumnsOptions = data.dimensionColumnsOptions;
      this.rebuildDimensionColumnLookup(this.dimensionColumnsOptions);
    }
    if (data.talentBenchReportOptions) {
      this.talentBenchReportOptions = data.talentBenchReportOptions;
    }
    if (data.savedReportData) {
      this.savedReportData = data.savedReportData;
    }

    // Only refresh report data for submit actions, not for form hidden
    if (data.actionType !== 'formHidden') {
      this.clearColumnLevelFilters();
      this.first = 0;
      if (this.reportFormData?.reportType == ReportType.GRAPH_REPORT) {
        this.applySelectedGraphType(this.reportFormData.defaultGraphType);
      }
      await this.getReportData();
    } else {
    }
  }

  private clearColumnLevelFilters(): void {
    this.searchColumnsArray.clear();
    this.columnSortStates = {};
    this.columnNullStates = {};
    this.appliedColumnFilters = [];
    this.moreFiltersPopover?.hide();
  }

  /**
   * Refreshes data that depends on reportConfig when fresh config is received
   */
  async refreshReportConfigData(): Promise<void> {
    try {
      // Refresh all columns data based on new reportConfig
      await this.setAllColumnsData();
      
      // Refresh dimension columns data if needed
      await this.getDimensionColumnsData();
      
      // Update UI elements that depend on reportConfig
      this.updateReportConfigDependentUI();
      
      // Trigger change detection to update the view
      this._changeDetectorRef.detectChanges();
    } catch (error) {
      // Handle error silently
    }
  }

  /**
   * Updates UI elements that depend on reportConfig
   */
  private updateReportConfigDependentUI(): void {
    // Update report name and description in the UI
    // The template will automatically pick up the updated reportConfig values
    
    // Update any other UI elements that depend on reportConfig
    // For example, if there are any computed properties or getters that use reportConfig
  }

  async selectDateRange(dateRange: any) {
    // Don't override existing data, just update the periodValue

    this.reportFormData.periodValue = +dateRange.code;
    //this._commonService.formLoaded = false;
    
    // Recapture applied filters when date range changes (column filters remain active)
    this.captureAppliedFilters();
    
    this.first = 0;

    await this.getReportData();
  }

  async getReportFormData(exportType: ExportType, isGraphReport: 1 | 0 = 0) {
    const teamReportIds = [9, 14, 16, 36];
    if (teamReportIds.includes(Number(this.reportFormData.reportId)) && this.generateReportForm?.reportForm) {
      this.getAndUpdateFormData();
    } else if (Number(this.reportFormData.reportId) === 109 || Number(this.reportFormData.reportId) === 110 && this.generateReportForm?.reportForm) {
      this.getAndUpdateFormData();
    } else if (!this.reportFormData.reportId || !this.reportFormData.businessUnitIds || this.reportFormData.businessUnitIds.length === 0) {
      this.getAndUpdateFormData();
    }

    let reportFormData: ReportFormData = {};
    reportFormData.reportId = this.reportFormData.reportId;
    reportFormData.reportName = (this.reportFormData.reportName) ? this.reportFormData.reportName : this.reportConfig.reportName;
    reportFormData.reportDesc = (this.reportFormData.reportDesc) ? this.reportFormData.reportDesc : this.reportConfig.reportDesc;
    reportFormData.businessUnitIds = this.reportFormData.businessUnitIds;
    reportFormData.reportType = this.reportFormData.reportType;
    reportFormData.dateFilterCol = this.normalizeDateFilterCol(this.reportFormData.dateFilterCol);
    reportFormData.periodValue = this.reportFormData.periodValue;
    if (this.reportFormData.periodValue == 10) {
      reportFormData.custStartDate = this.timezoneTransformPipe.transform(this.reportFormData.custStartDate, 'yyyy-MM-dd', this.loggedInUserTimeZone);
      reportFormData.custEndDate = this.timezoneTransformPipe.transform(this.reportFormData.custEndDate, 'yyyy-MM-dd', this.loggedInUserTimeZone);
      //reportFormData.custStartDate = this.reportFormData.custStartDate;
      //reportFormData.custEndDate = this.reportFormData.custEndDate;
    }
    if (this.reportFormData.reportId == 9) {
      reportFormData.filterType = Number(this.reportFormData.filterType);
      if (this.reportFormData.filterType == this.filterType.ROLE) {
        reportFormData.filterRole = this.reportFormData.filterRole;
        reportFormData.roleUserIds = this.reportFormData.roleUserIds;
      } else if (this.reportFormData.filterType == this.filterType.TEAM) {
        reportFormData.teamList = this.reportFormData.teamList;
        reportFormData.teamMembersList = this.reportFormData.teamMembersList;
      }
    } else if ([14, 16, 36].includes(this.reportFormData.reportId || 0)) {
      reportFormData.teamList = this.reportFormData.teamList;
      reportFormData.teamMembersList = this.reportFormData.teamMembersList;
    } else if (this.reportFormData.reportId == 20) {
      reportFormData.placementReportOn = this.reportFormData.placementReportOn;
      reportFormData.currencyDetails = this.reportFormData.currencyDetails;
      reportFormData.currencyConversion = this.reportFormData.currencyConversion;
      reportFormData.instanceType = this.reportFormData.instanceType;
    } else if (this.reportFormData.reportId == 5) {
      reportFormData.marketingStatus = this.reportFormData.marketingStatus;
      reportFormData.benchStatus = this.reportFormData.benchStatus;
      reportFormData.benchSubStatus = this.reportFormData.benchSubStatus;
    } else if (this.reportFormData.reportId == 6) {
      reportFormData.includePipelines = this.reportFormData.includePipelines ?? false;
    } else if (Number(this.reportFormData.reportId) === 109 || Number(this.reportFormData.reportId) === 110) {
      reportFormData.stages = Array.isArray(this.reportFormData.stages) && this.reportFormData.stages.length > 0
        ? this.reportFormData.stages
        : (this.stages || []).slice(0, 10).map((stage) => stage.code);
      if (Number(this.reportFormData.reportId) === 110) {
        reportFormData.usersList = Array.isArray(this.reportFormData.usersList) && this.reportFormData.usersList.length > 0
          ? this.reportFormData.usersList
          : (this.usersListOptions || []).slice(0, 10).map((user) => user.code);
      }
    }
    
    let tempPreDefinedFilters: number[] = [];
    if (this.reportFormData.preDefinedFilters) {
      console.log('this.reportFormData.preDefinedFilters', this.reportFormData.preDefinedFilters);
      this.reportFormData.preDefinedFilters.forEach((filter: any) => {
        if (filter[0]) {
          tempPreDefinedFilters.push(filter[0]);
        }
      });
    }
    reportFormData.preDefFilterIds = tempPreDefinedFilters;
    if (this.reportFormData.filters && this.reportFormData.filters.length > 0) {
      reportFormData.filters = this.reportFormData.filters.map((filter: any, index: number) => {
        let filterCondition = 'filterCondition' + index;
        const columnInfo = this.getColumnInfo(filter.columnId);
        const isDateColumn = columnInfo?.searchType == 2;
        const isDateRange = [13, 14].includes(Number(filter.dataType));
        let value = filter.value;
        let startDate = filter.startDate;
        let endDate = filter.endDate;

        // Only transform the fields that apply for the filter operator (matches save-report logic).
        // Transforming empty/invalid value|startDate|endDate together caused NG02100 on clients.
        if (isDateColumn) {
          if (isDateRange) {
            startDate = this.timezoneTransformPipe.transform(filter.startDate, 'yyyy-MM-dd', this.loggedInUserTimeZone);
            endDate = this.timezoneTransformPipe.transform(filter.endDate, 'yyyy-MM-dd', this.loggedInUserTimeZone);
          } else {
            value = this.timezoneTransformPipe.transform(filter.value, 'yyyy-MM-dd', this.loggedInUserTimeZone);
          }
        }

        return {
          id: filter.id,
          columnId: filter.columnId,
          searchType: columnInfo?.searchType || filter.searchType,
          dataType: filter.dataType,
          value,
          startDate,
          endDate,
          condition: filter[filterCondition]
        } as any;
      });
    }
    if (this.reportFormData.columns) {
      reportFormData.columnsList = this.reportFormData.columns;
    }
    reportFormData.orderByColumnsList = [];
    if (this.reportFormData.sortColumns) {
      reportFormData.orderByColumnsList = this.reportFormData.sortColumns.map((column: SortColumn) => ({ columnId: column.code, sortDir: column.sortOrder }));
    }
    if (this.reportFormData.groupByFilters?.length) {
      reportFormData.groupByColumnsList = this.reportFormData.groupByFilters;
    }
    console.log('this.reportFormData.groupByColumnsList', this.reportFormData.groupByColumnsList);
    console.log('isGraphReport', isGraphReport);
    if (isGraphReport == 1) {
      const graphGroupByFilters = this.getGraphGroupByFilters();
      if (graphGroupByFilters.length) {
        reportFormData.groupByColumnsList = graphGroupByFilters;
      }
    }
    reportFormData.groupByLevel = this.reportFormData.groupByLevel;
    // Add pagination parameters


    if (this.reportFormData.dimensionColumnId) {
      reportFormData.dimensionColumnId = this.reportFormData.dimensionColumnId;
    }

    reportFormData.userReportId = this.reportId;
    reportFormData.isAdminReport = this.reportFormData.isAdminReport;
    reportFormData.enableHierarchySecurity = this.reportFormData.enableHierarchySecurity ?? false;

    //default table/graph loading
    /* if (
      this.reportFormData?.reportType !== undefined &&
      Number(this.reportFormData.reportType) !== ReportType.DETAILED_REPORT &&
      Number(this.reportFormData.reportType) !== ReportType.DIMENSION_REPORT
    ) {
      this.isGraphReport = true;
    } else {
      this.isGraphReport = false;
    } */

    if (exportType) {
      reportFormData.exportType = exportType;
      // True grid total — backend uses this for instant vs BullMQ routing (≥10k).
      // Do not send page size (rows) here; that incorrectly forces the instant path.
      reportFormData.recordsTotal = this.totalRecords || 0;
    }
    if (isGraphReport == 1) {
      reportFormData.getChartData = 1;
    } else if (!exportType) {
      // Only include pagination for list loads — never for exports.
      if (!this.shouldDisablePagination()) {
        reportFormData.first = this.first;
        reportFormData.rows = this.rows;
      }
    }
    await this.applySearchFilters(reportFormData);
    return reportFormData;
  }

  async applySearchFilters(reportFormData: ReportFormData): Promise<any> {
    if (this.searchForm.valid) {
      const searchData = this.searchForm.value;
      // Process search data
      const columnSearchFilters: any = [];
      const columnSortFilters: any = [];
      const nullColumnsList: any = [];
      searchData.searchColumns.forEach((item: any) => {
        //searchParams[`searchColumn[${item.searchColumn}]`] = item.searchColumn;
        //searchParams[`searchValue[${item.searchColumn}]`] = item.searchValue;
        //searchParams[`sortValue[${item.searchColumn}]`] = item.sortValue;
        //searchParams[`nullValue[${item.searchColumn}]`] = item.nullValue;
        const columnInfo = this.getColumnInfo(item.searchColumn);
        if (item.searchValue != '') {
          let tempColumnSearchFilters = {
            id: null,
            columnId: item.searchColumn,
            searchType: columnInfo?.searchType || 1,
            dataType: (columnInfo?.searchType == 4) ? 15 : (columnInfo?.searchType == 2) ? 1 : 5,
            value: (columnInfo?.searchType == 2) ? this.timezoneTransformPipe.transform(item.searchValue, 'yyyy-MM-dd', this.loggedInUserTimeZone) : item.searchValue,
            startDate: "",
            endDate: "",
            condition: "AND"
          }
          columnSearchFilters.push(tempColumnSearchFilters);
        }
        if (item.sortValue != '') {
          let tempColumnSortFilters = {
            columnId: item.searchColumn,
            sortDir: item.sortValue
          }
          columnSortFilters.push(tempColumnSortFilters);
        }
        if (item.nullValue != '') {
          /*let tempColumnNullValueFilters = {
            columnId: item.searchColumn,
            condition: item.nullValue
          }
          nullColumnsList.push(tempColumnNullValueFilters);*/
          let tempColumnSearchFilters = {
            id: null,
            columnId: item.searchColumn,
            searchType: columnInfo?.searchType || 1,
            dataType: (item.nullValue == 'IS NULL') ? 3 : 4,
            value: item.nullValue,
            startDate: "",
            endDate: "",
            condition: "AND"
          }
          columnSearchFilters.push(tempColumnSearchFilters);
        }
      });
      if (columnSearchFilters.length > 0) {
        // Merge existing filters with new columnSearchFilters
        const existingFilters = reportFormData.filters || [];
        reportFormData.filters = [...existingFilters, ...columnSearchFilters];
      }
      if (columnSortFilters.length > 0) {
        // Merge existing orderByColumnsList with new columnSortFilters
        const existingOrderBy = reportFormData.orderByColumnsList || [];
        reportFormData.orderByColumnsList = [...existingOrderBy, ...columnSortFilters];
      }
      if (nullColumnsList.length > 0) {
        reportFormData.nullColumnsList = nullColumnsList;
      }
      // Here you can make API call with searchParams
      // this.performSearch(searchParams);
      return reportFormData;
    }
  }

  /**
   * Get current form data from generate-report-form component
   * @returns Current form data or null if component not available
   */
  getCurrentFormData(): any {
    if (this.generateReportForm && this.generateReportForm.reportForm) {
      return this.generateReportForm.reportForm.value;
    }
    return null;
  }

  /**
   * Get current form data and update local reportFormData
   * @param forceUpdate - Whether to force update even if form data seems empty
   * @returns Current form data
   */
  getAndUpdateFormData(): any {
    const currentFormData = this.getCurrentFormData();
    if (!currentFormData) {
      return null;
    }

    const hasValidData = !!currentFormData.reportId &&
      currentFormData.businessUnitIds &&
      currentFormData.businessUnitIds.length > 0;

    // Only sync from the child form when it has been populated; forceUpdate must not
    // overwrite saved report state with the form's empty defaults.
    if (hasValidData) {
      this.reportFormData = currentFormData;
    }

    return currentFormData;
  }

  async getReportData(exportType: any = '') : Promise<void> {
    
    this.loading = true;

    // Only get form data if we don't have valid data already
    if (!this.reportFormData.reportId || !this.reportFormData.businessUnitIds || this.reportFormData.businessUnitIds.length === 0) {
      const currentFormData = this.getAndUpdateFormData();
      if (currentFormData) {
      }
    }

    let custStartDate = this.reportFormData.custStartDate;
    let custEndDate = this.reportFormData.custEndDate;
    const tempReportFormData = await this.getReportFormData(exportType, this.isGraphReport);
    this.getReportPostData = tempReportFormData;
    this.columnLevelOptions = {};

    // return;
    if (Object.keys(tempReportFormData).length > 0 && tempReportFormData.columnsList && tempReportFormData.columnsList.length > 0) {
      this._commonHttpService.getReportData(tempReportFormData).subscribe((data: any) => {
        custStartDate = data.startDate;
        custEndDate = data.endDate;
        this.updateDateRange(custStartDate, custEndDate);
        const reportData = data.aaData || data;
        this.clearSafeHtmlCache();
        this.reportData = reportData;
        this.hasReportData = reportData && reportData.length > 0;
        // Emit report data for graph components
        if (this.isGraphReport) {
          this._commonService.updateGraphReportState(this.buildGraphReportStateConfig(reportData));
          // Prefer form-submitted graph type; Subject value can be lost on fresh navigation
          this.applySelectedGraphType(
            this.reportFormData?.defaultGraphType || this.currentDefaultGraphType || this.selectedGraphItem
          );

        } else {
          // process grouped data
          this.processGroupedData(reportData);
          
          // Check for hierarchy data and process it
          this.processHierarchyData(reportData);
        }

        this.totalRecords = data.iTotalRecords;
        this.loading = false;

      });
    } else {
      this.loading = false;
      if (this.generateReportForm) {
        setTimeout(() => {
          this.generateReportForm.showColumnsFormFields();
        }, 0);
      }
    }
    return Promise.resolve();
  }

  private processGroupedData(data: any[]): void {
    const { reportType, groupByLevel, groupByFilters } = this.reportFormData;

    // Convert reportType to number if it's a string
    const numericReportType = typeof reportType === 'string' ? parseInt(reportType) : reportType;

    if (numericReportType === ReportType.DETAILED_REPORT && groupByLevel) {
      if (groupByLevel == 1) {
        this.groupedData = this._groupingService.createSingleLevelGroups(data, this.reportFormData, this.allColumnsData);
      } else if (groupByLevel == 2) {
        this.groupedData = this._groupingService.createTwoLevelGroups(data, this.reportFormData, this.allColumnsData);
      } else if (groupByLevel == 3) {
        this.groupedData = this._groupingService.createThreeLevelGroups(data, this.reportFormData, this.allColumnsData);
      }
    } else {
      this.groupedData = groupByFilters && groupByFilters.length >= 1
        ? this.groupDataByFilters(data, groupByFilters)
        : [];
    }

  }

  /**
   * Processes hierarchy data if present in the report data
   * @param data Array of report data rows
   */
  private processHierarchyData(data: any[]): void {
    if (!data || data.length === 0) {
      this.isHierarchyData = false;
      this.hierarchyData = null;
      return;
    }

    // Check if any row contains hierarchyObject
    const hasHierarchyData = data.some(row => {
      const hasHierarchy = (row.hierarchyObject && row.hierarchyObject.id) || 
                          (row[row.length - 1] && row[row.length - 1].hierarchyObject && row[row.length - 1].hierarchyObject.id);
      return hasHierarchy;
    });
    
    if (hasHierarchyData) {
      this.isHierarchyData = true;
      this.showHierarchyReport = true;
      
      // Convert data to hierarchy format
      const hierarchyDataRows: HierarchyDataRow[] = data.map(row => {
        const hierarchyObject = row.hierarchyObject || 
                              (row[row.length - 1] && row[row.length - 1].hierarchyObject);
        return {
          ...row,
          hierarchyObject: hierarchyObject
        };
      });

      // Create hierarchy columns from report columns
      this.hierarchyColumns = this.createHierarchyColumns();
      
      // Build hierarchy structure
      this.hierarchyData = this.hierarchyService.buildHierarchy(hierarchyDataRows, this.hierarchyColumns);
    } else {
      this.isHierarchyData = false;
      this.hierarchyData = null;
      this.showHierarchyReport = false;
    }
  }

  /**
   * Creates hierarchy columns from report columns
   * @returns Array of hierarchy columns
   */
  private createHierarchyColumns(): HierarchyColumn[] {
    const columns: HierarchyColumn[] = [];
    
    if (this.reportFormData.columns) {
      this.reportFormData.columns.forEach((col: any) => {
        const processedCol = this.getColumnInfo(col);
        const finalCol = processedCol || col;
        
        // Skip username/name columns since hierarchy column already displays names
        const columnName = String(finalCol.columnName || finalCol.name || '').toLowerCase();
        const columnId = String(finalCol.columnId || finalCol.id || '').toLowerCase();
        
        if (columnName.includes('username') || 
            columnName.includes('name') || 
            columnName.includes('user') ||
            columnId.includes('username') || 
            columnId.includes('name') || 
            columnId.includes('user')) {
          return; // Skip this column
        }
        
        const isNumeric = finalCol.colDataType === 1; // Assuming '1' means numeric
        const hierarchyColumn = {
          columnId: finalCol.columnId || finalCol.id,
          columnName: finalCol.columnName || finalCol.name,
          dataType: finalCol.colDataType || '0',
          isNumeric: isNumeric,
          isSummable: isNumeric, // Only numeric columns can be summed
          description: typeof finalCol.description === 'string' ? finalCol.description.trim() : ''
        };
        columns.push(hierarchyColumn);
      });
    }
    return columns;
  }

  /**
   * Toggles between hierarchy and regular table view
   */
  toggleHierarchyView(): void {
    this.showHierarchyReport = !this.showHierarchyReport;
  }

  /**
   * Checks if the current report has hierarchy data
   * @returns boolean indicating if hierarchy data is available
   */
  hasHierarchyData(): boolean {
    return this.isHierarchyData && this.hierarchyData !== null;
  }



  groupDataByFilters(data: any[], groupByFilters: any[]): GroupInfo[] {
    if (!data || data.length === 0 || !groupByFilters || groupByFilters.length === 0) {
      return [];
    }

    if (groupByFilters.length === 1) {
      // Single level grouping
      return this._groupingService.createSingleLevelGroups(data, this.reportFormData, this.allColumnsData);
    } else if (groupByFilters.length === 2) {
      // Two level hierarchical grouping
      return this._groupingService.createTwoLevelGroups(data, this.reportFormData, this.allColumnsData);
    } else if (groupByFilters.length === 3) {
      // Three level hierarchical grouping
      return this._groupingService.createThreeLevelGroups(data, this.reportFormData, this.allColumnsData);
    }
    return [];
  }
  getTotalRecordsForGroupedData(): number {
    if (this.groupedData && this.groupedData.length > 0) {
      // For grouped data, count the total number of groups
      return this.groupedData.length;
    }
    return this.totalRecords;
  }

  getTableColumns(): any[] {
    // let tempColumns = this.reportFormData.columns?.map((col: any) => ({ ...col })) || [];
    let tempColumns = this.reportFormData.columns || [];
    if (this.reportFormData.reportType === ReportType.DETAILED_REPORT && this.reportFormData.groupByLevel) {
      tempColumns = tempColumns.slice(0, this.reportFormData.groupByLevel);
    }
    return tempColumns;
  }
  getTableColumnsForGroupedData(): any[] {
    let tempColumns: any[] = [];
    if (this.reportFormData.reportType === ReportType.DETAILED_REPORT) {
      tempColumns = this.reportFormData.columns?.map((col: any) => ({ ...col })) || [];
    } else {
      tempColumns = this.reportFormData.groupByFilters?.map((col: any) => ({ ...col })) || [];
    }
    if (this.reportFormData.reportType === ReportType.DETAILED_REPORT && this.reportFormData.groupByLevel) {
      tempColumns = tempColumns.slice(0, this.reportFormData.groupByLevel);
    }
    return tempColumns;
  }

  async onPageChange(event: any): Promise<void> {
    this.first = event.first;
    this.rows = event.rows;
    return await this.getReportData();
  }
  async onLazyLoad(event: any): Promise<void> {
    this.first = event.first;
    this.rows = event.rows;
    return await this.getReportData();
  }

  toggleGroup(group: any) {
    group.expanded = !group.expanded;
  }

  showCompanyReportsSubMenu() {
    /*if (Object.keys(this.companyReports).length > 0) {
      this.companyReportsSubMenuDisplay = true;
    } else {
      this.getCompanyReports().then(() => {
        this.companyReportsSubMenuDisplay = true;
      });
    }*/
    this.getCompanyReports().then(() => {
      this.companyReportsSubMenuDisplay = true;
    });
  }

  getCompanyReports() {
    return new Promise((resolve) => {
      this._commonHttpService.getReportsList('company-reports').subscribe((data: any) => {
        this.companyReports = data.data.modules;
        this.originalCompanyReports = data.data.modules; // Store original data
        resolve(true);
      });
    });
  }

  // Handle module selection change
  onModuleChange(event: any) {
    this.selectedModuleId = event.value;
    this.applyFilters();
  }

  // Handle text search
  onTextSearch(event: any) {
    this.searchText = event.target.value;
    this.applyFilters();
  }

  // Apply both module and text filters
  applyFilters() {
    // Create a deep copy of the original data to avoid modifying it
    const filteredReports = this.originalCompanyReports.filter((report: any) => {
      // Filter by selected module
      const moduleMatch = this.selectedModuleId ? report.id === this.selectedModuleId : true;

      if (!moduleMatch) {
        return false;
      }

      // If no search text, include all reports from the selected module
      if (!this.searchText) {
        return true;
      }

      const searchTextLower = this.searchText.toLowerCase();

      // Search in report.reportName
      const reportNameMatch = report.reportName && report.reportName.toLowerCase().includes(searchTextLower);

      // Search in saved reports
      const savedReportsMatch = report.savedReports && report.savedReports.some((savedReport: any) => {
        const savedNameMatch = savedReport.reportName && savedReport.reportName.toLowerCase().includes(searchTextLower);
        const savedDescMatch = savedReport.reportDesc && savedReport.reportDesc.toLowerCase().includes(searchTextLower);
        return savedNameMatch || savedDescMatch;
      });

      return reportNameMatch || savedReportsMatch;
    }).map((report: any) => {
      // Create a deep copy of the report
      const reportCopy = { ...report };

      // If there's search text, filter the savedReports
      if (this.searchText && reportCopy.savedReports) {
        const searchTextLower = this.searchText.toLowerCase();
        reportCopy.savedReports = reportCopy.savedReports.filter((savedReport: any) => {
          const savedNameMatch = savedReport.reportName && savedReport.reportName.toLowerCase().includes(searchTextLower);
          const savedDescMatch = savedReport.reportDesc && savedReport.reportDesc.toLowerCase().includes(searchTextLower);
          return savedNameMatch || savedDescMatch;
        });
      }

      return reportCopy;
    });

    this.companyReports = filteredReports;
  }

  searchCompanyReports(event: any) {
    // This method is called from the template for backward compatibility
    // It now delegates to the appropriate method based on event type
    if (event.target && event.target.value !== undefined) {
      // Text input event
      this.onTextSearch(event);
    } else if (event.value !== undefined) {
      // Select change event
      this.onModuleChange(event);
    }
  }

  loadCompanyReports() {
    return this.companyReports;
  }

  getModuleOptions() {
    return this.originalCompanyReports.map((module: any) => ({
      label: module.reportName,
      value: module.id
    }));
  }

  // Methods for show more functionality
  getVisibleSavedReports(savedReports: any[], moduleId: number): any[] {
    if (this.showMoreStates[moduleId]) {
      return savedReports;
    }
    return savedReports.slice(0, this.initialDisplayCount);
  }

  hasMoreReports(savedReports: any[], moduleId: number): boolean {
    return savedReports.length > this.initialDisplayCount && !this.showMoreStates[moduleId];
  }

  toggleShowMore(moduleId: number): void {
    this.showMoreStates[moduleId] = !(this.showMoreStates[moduleId] === true);
  }

  getShowMoreText(moduleId: number): string {
    return this.showMoreStates[moduleId] === true ? 'Show Less' : 'Show More';
  }

  // Helper methods for unified table
  getTableData(): any[] {
    if (this.isGroupedData()) {
      return this.groupedData;
    }
    return this.reportData;
  }

  /**
   * Checks if the report data is grouped
   * @returns boolean indicating if the report data is grouped
   * @author: PRachethan | 17-07-2025
   */
  isGroupedData(): boolean {
    const isGrouped = Boolean(
      (this.reportFormData?.groupByFilters && this.reportFormData?.groupByFilters.length > 0) ||
      (this.reportFormData?.groupByLevel && this.reportFormData?.groupByLevel > 0)
    );
    return isGrouped;
  }

  /**
   * Gets the unified table columns
   * @returns array of unified table columns
   * @author: PRachethan | 17-07-2025
   */
  getUnifiedTableColumns(): any[] {
    const groupByFilters = this.reportFormData?.groupByFilters || [];
    const columns = this.reportFormData?.columns || [];
    const cacheKey = `${groupByFilters.join(',')}|${columns.join(',')}`;
    if (this.unifiedTableColumnsCacheKey === cacheKey) {
      return this.unifiedTableColumnsCache;
    }
    this.unifiedTableColumnsCacheKey = cacheKey;
    this.unifiedTableColumnsCache = [...groupByFilters, ...columns];
    return this.unifiedTableColumnsCache;
  }

  /**
   * Gets the total number of records
   * @returns number of total records
   * @author: PRachethan | 17-07-2025
   */
  getTotalRecords(): number {
    return this.totalRecords;
  }

  /**
   * Gets the current page report template
   * @returns string indicating the current page report template
   * @author: PRachethan | 17-07-2025
   */
  getCurrentPageReportTemplate(): string {
    return "Showing {first} to {last} of {totalRecords} entries";
  }

  /**
   * Checks if a group has any group sums for display
   * @param rowData - The group data object
   * @returns boolean indicating if any group sums exist
   * @author: PRachethan | 17-07-2025
   */
  hasAnyGroupSums(rowData: any): boolean {
    if (!rowData.groupSums) {
      return false;
    }

    const columns = this.getUnifiedTableColumns();
    for (let i = 0; i < columns.length; i++) {
      if (rowData.groupSums[`sum_${i}`] !== undefined) {
        return true;
      }
    }
    return false;
  }

  /**
   * Checks if a sum has been displayed before the current index
   * @param rowData - The group data object
   * @param currentIndex - Current column index
   * @returns boolean indicating if a sum was displayed before
   * @author: PRachethan | 17-07-2025
   */
  hasDisplayedSumBefore(rowData: any, currentIndex: number): boolean {
    if (!rowData.groupSums) {
      return false;
    }

    for (let i = 0; i < currentIndex; i++) {
      if (rowData.groupSums[`sum_${i}`] !== undefined) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the remaining columns count for colspan calculation
   * @param rowData - The group data object
   * @param currentIndex - Current column index
   * @returns number of remaining columns
   */
  getRemainingColumnsCount(rowData: any, level: number = 1): number {

    return this.getFirstSumIndex(rowData) - level - 1;
  }

  /**
   * Gets the index of the first sum in groupSums
   * @param rowData - The group data object
   * @returns index of first sum, or -1 if no sum exists
   */
  getFirstSumIndex(rowData: any): number {
    if (!rowData.groupSums) {
      return -1;
    }

    const columns = this.getUnifiedTableColumns();
    for (let i = 0; i < columns.length; i++) {
      if (rowData.groupSums[`sum_${i}`] !== undefined) {
        return i;
      }
    }
    return -1;
  }

  /**
   * Checks if a column should be formatted as percentage
   * @param columnInfo - The column information object
   * @returns boolean indicating if it's a percentage field
   */
  isPercentageField(columnInfo: any): boolean {
    return columnInfo?.isPercentField == 1;
  }

  isAmountField(columnInfo: any): boolean {
    return columnInfo?.isAmountField == 1;
  }

  isNumericColumn(columnInfo: any): boolean {
    return columnInfo?.colDataType == 1;
  }

  /** 
   * Checks if a column should be formatted as currency/amount
   * @param columnInfo - The column information object
   * @returns boolean indicating if it's an amount field
   */
  

  private formatNumberWithCommas(value: number, decimalPlaces?: number): string {
    const minDecimals = decimalPlaces ?? (Number.isInteger(value) ? 0 : 2);
    const maxDecimals = decimalPlaces ?? (Number.isInteger(value) ? 0 : 2);
    return Number(value).toLocaleString('en-US', {
      minimumFractionDigits: minDecimals,
      maximumFractionDigits: maxDecimals
    });
  }

  private parseNumericCellValue(value: any): number {
    if (value === null || value === undefined || value === '') {
      return NaN;
    }
    if (typeof value === 'number') {
      return value;
    }
    const normalized = String(value).trim().replace(/,/g, '');
    if (normalized === '' || !/^-?\d+(\.\d+)?$/.test(normalized)) {
      return NaN;
    }
    const num = parseFloat(normalized);
    return isNaN(num) ? NaN : num;
  }

  /**
   * Formats a value based on column properties
   * @param value - The value to format
   * @param columnId - The column ID to get column info
   * @returns Formatted value as string
   */
  formatValue(value: any, columnId: any): string {
    const columnInfo = this.getColumnInfo(columnId);

    if (value === null || value === undefined || value === '') {
      if (columnInfo && this.isPercentageField(columnInfo)) {
        return '0.00 %';
      }
      if (columnInfo && this.isAmountField(columnInfo)) {
        return '0.00';
      }
      return '';
    }

    if (!columnInfo) {
      return String(value);
    }

    // Date columns: show exactly what get-data returned (no parseFloat / reformat / timezone)
    if (columnInfo.searchType == 2) {
      if (value == null || value === undefined || value === '') {
        return '';
      }
      const dateStr = String(value).trim();
      if (dateStr.startsWith('0000-00-00')) {
        return '';
      }
      return dateStr;
    }

    // Text/varchar columns: show the raw value (avoid parseFloat stripping trailing text).
    // Percentage columns are excluded because they may be stored as varchar but still need the % suffix.
    if (!this.isNumericColumn(columnInfo) && !this.isPercentageField(columnInfo)) {
      return String(value);
    }

    // Convert to number for formatting
    const numValue = this.parseNumericCellValue(value);
    if (isNaN(numValue)) {
      return String(value);
    }

    // Check if it's a percentage field
    const isPercentage = this.isPercentageField(columnInfo);
    const roundedValue = Number.isInteger(numValue) ? String(numValue) : numValue.toFixed(2);
    
    // Format as percentage
    if (isPercentage) {
      const formatted = `${roundedValue} %`;
      return formatted;
    }

    if (this.isAmountField(columnInfo)) {
      return this.formatNumberWithCommas(numValue, 2);
    }

    // Return as is for other types
    return roundedValue;
  }

  /**
   * Formats a number as currency
   * @param value - The numeric value to format
   * @returns Formatted currency string
   */
  formatCurrency(value: any, rowData: any): string {
    const orgData = rowData[rowData.length - 1];
    let currencyCode = orgData?.col__org_1680 || orgData?.col__org_3564 || '';

    const currencySymbols: { [key: string]: string } = {
      'USD': '$',
      'INR': '₹',
      'EUR': '€',
      'GBP': '£',
      'JPY': '¥',
      'CNY': '¥',
      'AUD': 'A$',
      'CAD': 'CAD',
      'CHF': 'CHF',
      'SGD': 'SGD'
    };
    const symbol = currencySymbols[currencyCode] || currencyCode;

    const numValue = this.parseNumericCellValue(value);
    if (isNaN(numValue)) {
      return symbol ? `${symbol}0.00` : '0.00';
    }

    const formattedValue = this.formatNumberWithCommas(numValue, 2);

    return symbol + formattedValue;
  }

  /**
   * Background color of a group row, derived from its hierarchical nesting depth
   * @param group - The group being rendered
   * @param isHeaderRow - False when the group renders as a plain data row, which keeps the default background
   * @returns Background color, or null to leave the row background untouched
   */
  getGroupRowBackground(group: GroupInfo | any, isHeaderRow: boolean = true): string | null {
    if (!isHeaderRow || !group) {
      return null;
    }
    // Summary/Dimension report with a single group column: no group row background
    if (this.isSummaryOrDimensionReport() && this.getGroupByColumnCount() === 1) {
      return null;
    }
    return this._groupingService.getGroupRowBackgroundColor(group.depth ?? 1);
  }

  /**
   * Formats a group sum value based on column properties
   * @param groupSums - The group sums object
   * @param columnIndex - The column index
   * @param columnId - The column ID
   * @returns Formatted group sum value
   */
  getGroupSumRaw(groupSums: any, columnIndex: number): number {
    const sumKey = `sum_${columnIndex}`;
    const value = groupSums?.[sumKey];
    return isNaN(value) ? NaN : Number(value);
  }

  formatGroupSum(groupSums: any, columnIndex: number, columnId: any): string {
    const columnInfo = this.getColumnInfo(columnId);

    // Do not show group summary/count for colDataType 3 columns
    if (columnInfo?.colDataType == 3) {
      return '';
    }

    const sumKey = `sum_${columnIndex}`;
    const value = groupSums?.[sumKey];

    if (value === undefined || value === null || isNaN(value)) {
      return '';
    }

    // Grouped records keep the % suffix for Client Score Card and summary reports
    if (this.isPercentageField(columnInfo)) {
      if (this.isClientScoreCardReport() || this.isSummaryReport()) {
        return this.formatValue(value, columnId);
      }
      const numValue = Number(value);
      return Number.isInteger(numValue) ? String(numValue) : numValue.toFixed(2);
    }

    // Summarized/grouped records: hide currency icon
    if (this.isAmountField(columnInfo)) {
      return this.formatNumberWithCommas(Number(value), 2);
    }

    return this.formatValue(value, columnId);
  }

  /** Client Score Card report — keep % on summarized/grouped record rows */
  isClientScoreCardReport(): boolean {
    return Number(this.reportFormData?.reportId || this.moduleId || this.reportId || 0) === 8;
  }

  isSummaryReport(): boolean {
    return this.getNumericReportType() === ReportType.SUMMARY_REPORT;
  }


  /**
   * Determines if drilldown link should be shown
   * @param groupSums - The group sums object
   * @param columnIndex - The column index
   * @param columnId - The column ID
   * @returns True if drilldown link should be displayed
   */
  shouldShowDrilldownLink(groupSums: any, columnIndex: number, columnId: any): boolean {
    const groupSumValue = this.getGroupSumRaw(groupSums, columnIndex);
    const columnInfo = this.getColumnInfo(columnId);

    if (!this.isNumericColumn(columnInfo) || isNaN(groupSumValue)) {
      return false;
    }

    return groupSumValue > 0 &&
      (columnInfo?.drilldownReportId || this.getNumericReportType() === ReportType.DIMENSION_REPORT);
  }

  /**
   * Determines if group sum should be shown (non-clickable)
   * @param groupSums - The group sums object
   * @param columnIndex - The column index
   * @param columnId - The column ID
   * @returns True if group sum should be displayed
   */
  shouldShowGroupSum(groupSums: any, columnIndex: number, columnId: any): boolean {
    const columnInfo = this.getColumnInfo(columnId);
    const showPercentValue =
      (this.isClientScoreCardReport() || this.isSummaryReport()) && this.isPercentageField(columnInfo);

    if (!this.isNumericColumn(columnInfo) && !showPercentValue) {
      return false;
    }

    const groupSumValue = this.getGroupSumRaw(groupSums, columnIndex);
    if (isNaN(groupSumValue)) {
      return false;
    }

    return !this.shouldShowDrilldownLink(groupSums, columnIndex, columnId);
  }

  shouldShowRowDrilldownLink(row: any, columnIndex: number, columnId: any): boolean {
    const columnInfo = this.getColumnInfo(columnId);
    if (!this.isNumericColumn(columnInfo) || !columnInfo?.drilldownReportId) {
      return false;
    }

    const cellValue = row?.[columnIndex];
    if (cellValue === null || cellValue === undefined || cellValue === '') {
      return false;
    }

    return !!+cellValue;
  }

  getRowDisplayValue(row: any, columnIndex: number, columnId: any): string {
    const columnInfo = this.getColumnInfo(columnId);
    if (columnInfo?.isAmountField == 1) {
      return this.formatCurrency(row[columnIndex], row);
    }
    return this.formatValue(row[columnIndex], columnId);
  }

  isSummaryOrDimensionReport(): boolean {
    const reportType = this.getNumericReportType();
    return reportType === ReportType.SUMMARY_REPORT || reportType === ReportType.DIMENSION_REPORT;
  }

  getGroupByColumnCount(): number {
    if (this.isDetailedReport()) {
      return Number(this.reportFormData?.groupByLevel) || 0;
    }
    return this.reportFormData?.groupByFilters?.length || 0;
  }

  shouldShowGroupDetailRows(): boolean {
    const reportType = this.getNumericReportType();
    return reportType !== ReportType.SUMMARY_REPORT &&
      reportType !== ReportType.DIMENSION_REPORT &&
      reportType !== ReportType.GRAPH_REPORT;
  }

  /**
   * Gets the overall total sums for all grouped data
   * @returns Object containing total sums for each column
   */
  getOverallTotalSums(): any {
    if (!this.groupedData || this.groupedData.length === 0) {
      return {};
    }

    const totalSums: any = {};

    // Iterate through all groups and accumulate their totalSums
    this.groupedData.forEach(group => {
      if (group.totalSum) {
        Object.keys(group.totalSum).forEach(key => {
          if (!totalSums[key]) {
            totalSums[key] = 0;
          }
          totalSums[key] += group.totalSum[key];
        });
      }
    });

    return totalSums;
  }

  /**
   * Formats the overall total sum for a specific column
   * @param columnIndex - The column index
   * @param columnId - The column ID
   * @returns Formatted total sum value
   */
  formatOverallTotalSum(columnIndex: number, columnId: any): string {
    const columnInfo = this.getColumnInfo(columnId);

    if (this.isPercentageField(columnInfo)) {
      return '';
    }

    // If column is not numeric, return empty string
    if (columnInfo?.colDataType != 1) {
      return '';
    }

    const totalSums = this.getOverallTotalSums();
    const sumKey = `sum_${columnIndex}`;
    const value = totalSums?.[sumKey];
    let dataSum = 0;

    if (value === undefined || value === null || isNaN(value)) {
      this.reportData.forEach((row: any) => {
        if (row[columnIndex] != null && row[columnIndex] !== '' && columnInfo?.colDataType == 1) {
          dataSum += parseFloat(row[columnIndex]) || 0;
        }
      });
    } else {
      dataSum = value;
    }

    if (this.isAmountField(columnInfo)) {
      return this.formatNumberWithCommas(Number(dataSum), 2);
    }

    return this.formatValue(dataSum, columnId);
  }

  /**
   * Checks if the current report should display single level grouping
   * @returns True if single level grouping should be displayed
   */
  shouldDisplaySingleLevelGrouping(): boolean {
    return this.getGroupByColumnCount() === 1;
  }

  shouldDisplayTwoLevelGrouping(): boolean {
    return this.getGroupByColumnCount() === 2;
  }

  shouldDisplayThreeLevelGrouping(): boolean {
    return this.getGroupByColumnCount() === 3;
  }

  // Helper method to get numeric report type
  getNumericReportType(): number {
    const reportType = this.reportFormData?.reportType;
    if (reportType === undefined || reportType === null) {
      return 0; // Default to DETAILED_REPORT
    }
    return typeof reportType === 'string' ? parseInt(reportType) : reportType;
  }

  // Helper method to check if it's DETAILED_REPORT
  isDetailedReport(): boolean {
    return this.getNumericReportType() === ReportType.DETAILED_REPORT;
  }


  async exportReport(type: ExportType, actionType: number) {

    if (actionType == 1) {
      if (type == "email") {
        // Set the report data for email form
        let reportData: any = await this.getReportFormData(type);
        //reportData.reportConfig = this.reportConfig;
        this._commonService.emailReportData = reportData;
        // Show the email report form
        this._commonService.showEmailReport();
      } else if (type == "schedule") {
        this.showScheduleReport(this.savedReportData.savedReports[0]);
        this._commonService.showScheduleReport();
      } else {
        this.loading = true;
        const reportFormData = await this.getReportFormData(type);
        this._commonHttpService.getReportData(reportFormData).subscribe({
          next: (data: ExportResponse) => {
            this.loading = false;

            if (data.success === 1) {
              this._commonMethods.showToastMessage(data.message || 'Report exported successfully', 'Report Exported', Severity.success);
              if (data.reportUrl && data.reportUrl.trim() != '')
                window.open(data.reportUrl, '_blank');
            } else {
              if (data.redirectUrl) {
                this._commonMethods.showToastMessage(data.message || 'Authentication required to export report to Google Sheet', 'Authentication Required', Severity.error);
                window.open(data.redirectUrl, '_blank');
              } else {
                this._commonMethods.showToastMessage(data.message || 'Report Export Failed', 'Report Export Failed', Severity.error);
              }
            }

          },
          error: (error) => {
            this.loading = false;
          }
        });
      }
    } else if (actionType == 2) {
      this.exportGraph(type);
    }

  }

  exportGraph(type: ExportType) {
    // Graph export functionality removed - implement as needed
    this.baseChartService.exportGraph(this.selectedGraphItem, type);
  }

  /** Cache SafeHtml so CD (e.g. mousemove while selecting) does not reassign innerHTML and clear selection. */
  private safeHtmlCache = new Map<string, SafeHtml>();

  /**
   * Renders HTML cell content (e.g. anchor tags from the API) without breaking text selection.
   */
  getSafeHtml(value: any): SafeHtml {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const html = String(value);
    const cached = this.safeHtmlCache.get(html);
    if (cached) {
      return cached;
    }
    const safe = this.sanitizer.bypassSecurityTrustHtml(html);
    this.safeHtmlCache.set(html, safe);
    return safe;
  }

  private clearSafeHtmlCache(): void {
    this.safeHtmlCache.clear();
  }

  ngAfterViewInit() {
    // Optional: if data comes from navigation state
    if (this.router.getCurrentNavigation()?.extras?.state) {
      const state = this.router.getCurrentNavigation()?.extras?.state;
    }
  }

  showScheduleReport(reportData: any) {
    // Set the report data first
    this._commonService.scheduleReportData = reportData;
    // Then show the schedule report
    this._commonService.showScheduleReport();
  }

  /**
   * Get dynamic tooltip text for schedule report icon
   * @returns string - Dynamic tooltip text based on scheduling status
   */
  getScheduleReportTooltip(): string {
    if (this.savedReportData?.savedReports?.[0]?.isScheduledReport) {
      return 'Scheduled report';
    } 
    return 'Schedule report';
  }
  getTaggedReportTooltip(): string {
    if (this.savedReportData?.savedReports?.[0]?.isTaggedReport == 0) {
      return 'Tag report';
    } else {
      return 'Untag report';
    }
  }

  /**
   * Get tooltip text for date range buttons
   * @param dateRange - The date range object with code and name
   * @returns string - Descriptive tooltip text
   */
  getDateRangeTooltip(dateRange: any): string {
    const tooltipMap: { [key: string]: string } = {
      '1': 'Today',
      '2': 'Yesterday', 
      '3': 'Current Week',
      '4': 'Month To Till Date',
      '5': 'Last Week',
      '11': 'Last Month',
      '12': 'This Year',
      '18': 'All',
      '50': 'Current Month'
    };
    
    return tooltipMap[dateRange.code] || dateRange.name;
  }
  showReportSecurity(reportData: any) {
    // Set the report data first
    reportData.reportFrom = 2;  
    this._commonService.reportLevelSecurityData = reportData;
    // Then show the schedule report
    this._commonService.showReportLevelSecurity();
  }

  updateDateRange(startDate: any, endDate: any) {
    const start = toCalendarDate(startDate);
    const end = toCalendarDate(endDate);
    if (start && end) {
      this.dateRange = [start, end];
    }
  }

  async dateRangeChanged() {
    if (this.dateRange && this.dateRange.length === 2) {
      this.reportFormData.custStartDate = this.dateRange[0];
      this.reportFormData.custEndDate = this.dateRange[1];
      this.reportFormData.periodValue = 10;

      // Trigger change detection to update the child component
      //this.triggerChangeDetection();
      
      // Recapture applied filters when date range changes (column filters remain active)
      this.captureAppliedFilters();

      await this.getReportData();
    }
  }

  private triggerChangeDetection() {
    // Force change detection to update the child component
    if (this.generateReportForm) {
      // Trigger change detection by creating a new reference
      this.reportFormData = { ...this.reportFormData };
    }
  }

  // Search form methods
  get searchColumnsArray(): FormArray {
    return this.searchForm.get('searchColumns') as FormArray;
  }

  getColumnFilterValue(column: any) {
    // Initialize column options if not already loaded
    if (!this.columnLevelOptions[column]) {
      this.loadColumnOptions(column);
    }

    // Add search column to form if not exists
    const existingIndex = this.searchColumnsArray.controls.findIndex(
      control => control.get('searchColumn')?.value === column
    );

    if (existingIndex === -1) {
      this.addSearchColumn(column);
    }

    // Log current state for debugging
  }

  loadColumnOptions(column: any) {
    const columnInfo = this.getColumnInfo(column);
    if (columnInfo?.searchType === 4) {
      // Load dropdown options for the column
      this._commonHttpService.makeFilterDropDowns(this.buildFilterDropdownPayload(column, {}, true)).subscribe((res: any) => {
        if (res.status == 1) {
          this.columnLevelOptions[column] = res.options || [];
        } else {
          this.columnLevelOptions[column] = [];
        }
      });
    } else {
      this.columnLevelOptions[column] = [];
    }
  }

  addSearchColumn(column: any) {
    // Check if column already exists to avoid duplicates
    const existingIndex = this.searchColumnsArray.controls.findIndex(
      control => control.get('searchColumn')?.value === column
    );

    if (existingIndex === -1) {
      const searchColumnGroup = this.fb.group({
        searchColumn: [column, Validators.required],
        searchValue: [''],
        sortValue: [''],
        nullValue: ['']
      });

      this.searchColumnsArray.push(searchColumnGroup);
    } else {
    }
  }

  removeSearchColumn(index: number) {
    this.searchColumnsArray.removeAt(index);
  }

  submitSearch() {
    /*if (this.searchForm.valid) {
      const searchData = this.searchForm.value;
      
      // Process search data
      const searchParams: any = {};
      searchData.searchColumns.forEach((item: any) => {
        searchParams[`searchColumn[${item.searchColumn}]`] = item.searchColumn;
        searchParams[`searchValue[${item.searchColumn}]`] = item.searchValue;
        searchParams[`sortValue[${item.searchColumn}]`] = item.sortValue;
        searchParams[`nullValue[${item.searchColumn}]`] = item.nullValue;
      });
      
      // Here you can make API call with searchParams
      // this.performSearch(searchParams);
    }*/
    
    // Capture the current filter state as applied filters
    this.captureAppliedFilters();
    
    this.first = 0;
    this.getReportData();
  }
  
  // Method to capture current filter state when search button is clicked
  captureAppliedFilters() {
    const appliedFilters: any[] = [];
    
    this.searchColumnsArray.controls.forEach((control) => {
      const column = control.get('searchColumn')?.value;
      const searchValue = control.get('searchValue')?.value;
      const sortValue = control.get('sortValue')?.value;
      const nullValue = control.get('nullValue')?.value;
      const columnInfo = this.getColumnInfo(column);
      
      if (searchValue && searchValue !== '' && searchValue !== null && searchValue !== undefined) {
        appliedFilters.push({
          column: column,
          columnName: columnInfo?.columnName || column,
          value: searchValue,
          displayValue: this.getFilterDisplayValue(column, searchValue),
          type: 'search'
        });
      }
      
      if (sortValue && sortValue !== '') {
        appliedFilters.push({
          column: column,
          columnName: columnInfo?.columnName || column,
          value: sortValue,
          displayValue: sortValue === 'ASC' ? '↑ Ascending' : '↓ Descending',
          type: 'sort'
        });
      }
      
      if (nullValue && nullValue !== '') {
        appliedFilters.push({
          column: column,
          columnName: columnInfo?.columnName || column,
          value: nullValue,
          displayValue: nullValue === 'IS NULL' ? 'Is Null' : 'Is Not Null',
          type: 'null'
        });
      }
    });
    
    this.appliedColumnFilters = appliedFilters;
    this.moreFiltersPopover?.hide();
  }

  async resetSearch(column: any) {

    // Remove search column items that match the specified column
    const searchColumnsArray = this.searchForm.get('searchColumns') as FormArray;
    const indicesToRemove: number[] = [];

    // Find indices of items to remove
    searchColumnsArray.controls.forEach((control, index) => {
      if (control.get('searchColumn')?.value === column) {
        indicesToRemove.push(index);
      }
    });

    // Remove items in reverse order to maintain correct indices
    indicesToRemove.reverse().forEach(index => {
      searchColumnsArray.removeAt(index);
    });

    this.columnSortStates[column] = '';
    this.columnSortStates[column + '_asc'] = false;
    this.columnSortStates[column + '_desc'] = false;
    this.columnNullStates[column] = '';
    this.columnNullStates[column + '_not_null'] = false;
    this.columnNullStates[column + '_null'] = false;

    // Update applied filters after reset
    this.captureAppliedFilters();

    this.first = 0;
    await this.getReportData();
  }

  getSearchColumnValue(column: any): string {
    const searchColumn = this.searchColumnsArray.controls.find(
      control => control.get('searchColumn')?.value === column
    );
    return searchColumn?.get('searchValue')?.value || '';
  }

  checkColumnFilterApplied(column: any): boolean {
    const searchColumn = this.searchColumnsArray.controls.find(
      control => control.get('searchColumn')?.value === column
    );
    return !!(searchColumn && (searchColumn?.get('searchValue')?.value != '' || searchColumn?.get('sortValue')?.value != '' || searchColumn?.get('nullValue')?.value != ''));
  }

  updateSearchValue(column: any, value: any) {
    const searchColumn = this.searchColumnsArray.controls.find(
      control => control.get('searchColumn')?.value === column
    );
    if (searchColumn) {
      searchColumn.get('searchValue')?.setValue(value);
    }
  }

  updateSearchTextValue(column: any, event: any) {
    const searchColumn = this.searchColumnsArray.controls.find(
      control => control.get('searchColumn')?.value === column
    );
    if (searchColumn) {
      searchColumn.get('searchValue')?.setValue(event.target.value);
    }
  }

  // Method to get current search form data
  getCurrentSearchData1() {
    const formData = this.searchForm.value;
    const searchParams: any = {};

    if (formData.searchColumns && formData.searchColumns.length > 0) {
      formData.searchColumns.forEach((item: any) => {
        searchParams[`searchColumn[${item.searchColumn}]`] = item.searchColumn;
        searchParams[`searchValue[${item.searchColumn}]`] = item.searchValue;
        searchParams[`sortValue[${item.searchColumn}]`] = item.sortValue;
        searchParams[`nullValue[${item.searchColumn}]`] = item.nullValue;
      });
    }

    return searchParams;
  }

  // Method to log current search form state (for debugging)
  logSearchFormState() {
    // Search form state logging removed
  }

  tagAndUntagReport(reportData: any) {
    this._commonHttpService.tagAndUntagReport(reportData).subscribe((res: any) => {
      if (res.status == 1) {
        this._commonMethods.showToastMessage(res.message, 'Success', Severity.success);
      }
    });
  }

  // Method to get current filter values for display
  getCurrentFilterValues(): any {
    const filterValues: any = {};
    this.searchColumnsArray.controls.forEach((control) => {
      const column = control.get('searchColumn')?.value;
      const value = control.get('searchValue')?.value;
      if (column && value) {
        filterValues[column] = value;
      }
    });
    return filterValues;
  }

  // Method to check if any filters are active (applied filters only)
  hasActiveFilters(): boolean {
    return this.appliedColumnFilters && this.appliedColumnFilters.length > 0;
  }

  // Method to get active column filters for chip display (returns applied filters)
  getActiveColumnFilters(): any[] {
    return this.appliedColumnFilters || [];
  }

  getVisibleActiveColumnFilters(): any[] {
    const activeFilters = this.getActiveColumnFilters();
    return activeFilters.slice(0, this.maxVisibleFilterChips);
  }

  getRemainingActiveColumnFilters(): any[] {
    return this.getActiveColumnFilters().slice(this.maxVisibleFilterChips);
  }

  shouldShowMoreFilterChipsButton(): boolean {
    return this.getActiveColumnFilters().length > this.maxVisibleFilterChips;
  }

  getRemainingFilterChipCount(): number {
    return Math.max(this.getActiveColumnFilters().length - this.maxVisibleFilterChips, 0);
  }

  // Method to format filter value for display in chip
  getFilterDisplayValue(column: any, value: any): string {
    const columnInfo = this.getColumnInfo(column);
    
    // Handle date filters
    if (columnInfo?.searchType === 2) {
      try {
        const dateValue = toCalendarDate(value);
        if (!dateValue) {
          return String(value);
        }
        
        // Use a proper date format for display (fix lowercase mm to uppercase MM for months)
        const displayFormat = this.defaultDateFormat.replace(/mm/g, 'MM');
        return this.timezoneTransformPipe.transform(dateValue, displayFormat, this.loggedInUserTimeZone);
      } catch (error) {
        console.error('Error formatting date:', error);
        return String(value);
      }
    }
    
    // Handle dropdown filters (multi-select)
    if (columnInfo?.searchType === 4 && Array.isArray(value)) {
      if (value.length === 0) return '';

      return value
        .map((selectedValue: any) => {
          const option = this.columnLevelOptions[column]?.find((opt: any) => opt.code == selectedValue);
          return option?.name || selectedValue;
        })
        .join(', ');
    }
    
    // Handle single dropdown value
    if (columnInfo?.searchType === 4 && this.columnLevelOptions[column]) {
      const option = this.columnLevelOptions[column].find((opt: any) => opt.code == value);
      return option?.name || value;
    }
    
    // Handle text filters
    if (typeof value === 'string' && value.length > 30) {
      return value.substring(0, 30) + '...';
    }
    
    return String(value);
  }

  getActiveFilterDisplayValue(filter: any): string {
    const columnInfo = this.getColumnInfo(filter.column);
    const value = filter.value;

    if (columnInfo?.searchType === 4 && Array.isArray(value)) {
      if (value.length === 0) return '';

      return value
        .map((selectedValue: any) => {
          const option = this.columnLevelOptions[filter.column]?.find((opt: any) => opt.code == selectedValue);
          return option?.name || selectedValue;
        })
        .join(', ');
    }

    return filter.displayValue;
  }

  // Method to remove a specific filter chip
  removeFilterChip(filter: any) {
    const searchColumn = this.searchColumnsArray.controls.find(
      control => control.get('searchColumn')?.value === filter.column
    );
    
    if (searchColumn) {
      if (filter.type === 'search') {
        searchColumn.get('searchValue')?.setValue('');
      } else if (filter.type === 'sort') {
        searchColumn.get('sortValue')?.setValue('');
        // Also clear the sort state
        this.columnSortStates[filter.column + '_asc'] = false;
        this.columnSortStates[filter.column + '_desc'] = false;
      } else if (filter.type === 'null') {
        searchColumn.get('nullValue')?.setValue('');
        // Also clear the null state
        this.columnNullStates[filter.column + '_null'] = false;
        this.columnNullStates[filter.column + '_not_null'] = false;
      }
    }
    
    // Remove from applied filters
    this.appliedColumnFilters = this.appliedColumnFilters.filter(
      f => !(f.column === filter.column && f.type === filter.type)
    );
    if (!this.shouldShowMoreFilterChipsButton()) {
      this.moreFiltersPopover?.hide();
    }
    
    // Trigger search to update the table with new filters
    this.first = 0;
    this.getReportData();
  }

  async clearAllFilterChips(): Promise<void> {
    this.clearColumnLevelFilters();
    this.first = 0;
    await this.getReportData();
  }

  // Method to handle sort selection
  handleSortSelection(column: any, sortType: 'asc' | 'desc') {
    const currentSort = this.columnSortStates[column];

    // If clicking the same sort type, deselect it
    if (currentSort === sortType) {
      this.columnSortStates[column] = '';
      // Also clear the ngModel binding
      this.columnSortStates[column + '_' + sortType] = false;
    } else {
      // Otherwise, select the new sort type (this automatically deselects the other)
      this.columnSortStates[column] = sortType;
      // Set the ngModel binding for the selected sort
      this.columnSortStates[column + '_' + sortType] = true;
      // Clear the other sort's ngModel binding
      this.columnSortStates[column + '_' + (sortType === 'asc' ? 'desc' : 'asc')] = false;
    }

    // Update the form control with proper sort value
    let sortValue = '';
    if (this.columnSortStates[column] === 'asc') {
      sortValue = 'ASC';
    } else if (this.columnSortStates[column] === 'desc') {
      sortValue = 'DESC';
    }
    this.updateSearchSortValue(column, sortValue);

  }

  // Method to get current sort state for a column
  getColumnSortState(column: any): string {
    const state = this.columnSortStates[column];
    return typeof state === 'string' ? state : '';
  }

  // Method to check if ascending sort is selected for a column
  isAscSortSelected(column: any): boolean {
    return this.columnSortStates[column] === 'asc';
  }

  // Method to check if descending sort is selected for a column
  isDescSortSelected(column: any): boolean {
    return this.columnSortStates[column] === 'desc';
  }

  // Method to handle null/not null selection
  handleNullSelection(column: any, nullType: 'not_null' | 'null') {
    const currentNullState = this.columnNullStates[column];

    // If clicking the same null type, deselect it
    if (currentNullState === nullType) {
      this.columnNullStates[column] = '';
      // Also clear the ngModel binding
      this.columnNullStates[column + '_' + nullType] = false;
    } else {
      // Otherwise, select the new null type (this automatically deselects the other)
      this.columnNullStates[column] = nullType;
      // Set the ngModel binding for the selected null type
      this.columnNullStates[column + '_' + nullType] = true;
      // Clear the other null type's ngModel binding
      this.columnNullStates[column + '_' + (nullType === 'not_null' ? 'null' : 'not_null')] = false;
    }

    // Update the form control with proper null value
    let nullValue = '';
    if (this.columnNullStates[column] === 'not_null') {
      nullValue = 'IS NOT NULL';
    } else if (this.columnNullStates[column] === 'null') {
      nullValue = 'IS NULL';
    }
    this.updateSearchNullValue(column, nullValue);

  }

  // Method to get current null state for a column
  getColumnNullState(column: any): string {
    const state = this.columnNullStates[column];
    return typeof state === 'string' ? state : '';
  }

  // Method to check if "Is Not Null" is selected for a column
  isNotNullSelected(column: any): boolean {
    return this.columnNullStates[column] === 'not_null';
  }

  // Method to check if "Is Null" is selected for a column
  isNullSelected(column: any): boolean {
    return this.columnNullStates[column] === 'null';
  }

  updateSearchSortValue(column: any, sortValue: string) {
    const searchColumn = this.searchColumnsArray.controls.find(
      control => control.get('searchColumn')?.value === column
    );
    if (searchColumn) {
      searchColumn.get('sortValue')?.setValue(sortValue);
    }
  }

  updateSearchNullValue(column: any, nullValue: string) {
    const searchColumn = this.searchColumnsArray.controls.find(
      control => control.get('searchColumn')?.value === column
    );
    if (searchColumn) {
      searchColumn.get('nullValue')?.setValue(nullValue);
    }
  }

  // Method to get the display value for null filter
  getNullDisplayValue(column: any): string {
    const nullValue = this.getSearchColumnNullValue(column);
    return nullValue || '';
  }

  // Method to get null value from form control
  getSearchColumnNullValue(column: any): string {
    const searchColumn = this.searchColumnsArray.controls.find(
      control => control.get('searchColumn')?.value === column
    );
    return searchColumn?.get('nullValue')?.value || '';
  }

  // Method to get the display value for sort filter
  getSortDisplayValue(column: any): string {
    const sortValue = this.getSearchColumnSortValue(column);
    return sortValue || '';
  }

  // Method to get sort value from form control
  getSearchColumnSortValue(column: any): string {
    const searchColumn = this.searchColumnsArray.controls.find(
      control => control.get('searchColumn')?.value === column
    );
    return searchColumn?.get('sortValue')?.value || '';
  }

  /**
   * Handles query parameters for Google Sheets authentication status
   * @author: PRachethan | 17-07-2025
   */
  private handleQueryParams(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['success'] === 'google_sheets_auth_success') {
        this._commonMethods.showToastMessage(
          'Google Sheets authentication successful. You can now export reports to Google Sheets.',
          'Authentication Success',
          Severity.success
        );
        // Clear the success query parameter to prevent showing toast on reload
        this.clearQueryParams(['success']);
      } else if (params['error'] === 'google_sheets_auth_failed') {
        this._commonMethods.showToastMessage(
          'Google Sheets authentication failed. Please try again',
          'Authentication Failed',
          Severity.error
        );
        // Clear the error query parameter to prevent showing toast on reload
        this.clearQueryParams(['error']);
      }
    });
  }

  /**
   * Clears specified query parameters from the URL
   * @param paramsToRemove - Array of parameter names to remove
   * @author: PRachethan | 17-07-2025
   */
  private clearQueryParams(paramsToRemove: string[]): void {
    const currentParams = { ...this.activatedRoute.snapshot.queryParams };

    // Remove the specified parameters
    paramsToRemove.forEach(param => {
      delete currentParams[param];
    });

    // Build the new URL without the specified query parameters
    const currentUrl = this.router.url.split('?')[0]; // Get base URL without query params
    const queryString = new URLSearchParams(currentParams).toString();
    const newUrl = queryString ? `${currentUrl}?${queryString}` : currentUrl;

    // Replace the current URL in browser history without adding a new entry
    window.history.replaceState({}, '', newUrl);
  }

  private getGroupByColumnIds(): (string | number)[] {
    if (this.isDetailedReport()) {
      return (this.reportFormData.columns || []).slice(0, this.getGroupByColumnCount());
    }
    return (this.reportFormData.groupByFilters || []) as (string | number)[];
  }

  private getOrgColFilterValue(orgColObject: any, columnId: string | number): any {
    if (!orgColObject) {
      return undefined;
    }
    const columnInfo = this.allColumnsData?.[columnId];
    const orgKeys = [
      columnInfo?.id != null ? `col__org_${columnInfo.id}` : null,
      `col__org_${columnId}`
    ].filter(Boolean) as string[];

    for (const orgKey of orgKeys) {
      const value = orgColObject[orgKey];
      if (value !== undefined && value !== null && value !== '') {
        return value;
      }
    }
    return undefined;
  }

  private getOrgColObjectFromGroup(row: any): any {
    if (row?.rows?.length > 0) {
      const dataRow = row.rows[0];
      return dataRow[dataRow.length - 1];
    }
    if (row?.subgroups?.length > 0) {
      const nestedRow = row.subgroups[0]?.rows?.[0];
      if (nestedRow) {
        return nestedRow[nestedRow.length - 1];
      }
    }
    return {};
  }

  /**
   * Builds drilldown filters aligned with legacy report_details.js getDrilldownData().
   *
   * Detailed report:
   * - level 0: row primary key (filterColumn 0 / col__org_0)
   * - level 1: group column 1
   * - level 2: group columns 1 + 2
   * - level 3: group columns 1 + 2 + 3
   *
   * Summary / dimension report:
   * - level 1: group column 1 (leaf group)
   * - level 2: group columns 1 + 2
   * - level 3: group columns 1 + 2 + 3
   */
  private buildDrilldownObject(
    row: any,
    column: any,
    level: number,
    parentGroups: any[] = []
  ): any[] {
    const drilldownObject: any[] = [];

    if (level === 0) {
      if (this.isDetailedReport() && Array.isArray(row)) {
        const orgColObject = row[row.length - 1];
        drilldownObject.push({
          filterColumn: 0,
          filterValue: orgColObject?.col__org_0
        });
      }
      return drilldownObject;
    }

    const groupColumnIds = this.getGroupByColumnIds();

    if (
      level === 1 &&
      this.isDetailedReport() &&
      groupColumnIds.includes(154) &&
      column == 158 &&
      row?.rows?.length
    ) {
      const userIds: any[] = [];
      row.rows.forEach((subRow: any) => {
        const lastObject = subRow[subRow.length - 1];
        if (lastObject.col__org_155 == 0) {
          lastObject.col__org_155 = null;
        }
        userIds.push(lastObject.col__org_155);
      });
      drilldownObject.push({ filterColumn: 154, filterValue: userIds });
      return drilldownObject;
    }

    for (let i = 0; i < level; i++) {
      const columnId = groupColumnIds[i];
      if (columnId === undefined || columnId === null) {
        continue;
      }

      let filterValue: any;
      if (i < parentGroups.length) {
        filterValue = parentGroups[i]?.groupKey;
      } else if (i === level - 1) {
        filterValue = row?.groupKey;
      }

      if (filterValue === undefined || filterValue === null || filterValue === '') {
        const sourceRow = i < parentGroups.length ? parentGroups[i] : row;
        filterValue = this.getOrgColFilterValue(this.getOrgColObjectFromGroup(sourceRow), columnId);
      }

      // Always include the filter entry; empty/null values must be sent as ""
      if (filterValue === undefined || filterValue === null) {
        filterValue = '';
      }

      drilldownObject.push({
        filterColumn: columnId,
        filterValue
      });
    }

    return drilldownObject;
  }

  async getDrilldownReport(row: any, column: any, level: number, hierarchicalDrilldownObject: any = {}, parentGroups: any[] = []) {
    this.drilldownReportInfo = {};
    this.drilldownReportInfo.drilldownColId = column;
    this.drilldownReportInfo.isDimensionReport = (this.reportFormData.reportType == ReportType.DIMENSION_REPORT) ? 1 : 0;
    this.drilldownReportInfo.drilldownReportId = this.drilldownReportInfo.isDimensionReport ? this.reportFormData.reportId : this.getColumnInfo(column)?.drilldownReportId;
    this.drilldownColumnInfo = await this.getDrilldownColumns(this.drilldownReportInfo);

    // Store the original structure for report name
    const originalDrilldownColumnInfo = this.drilldownColumnInfo;

    // Transform drilldownColumnInfo to array format for child component
    if (this.drilldownColumnInfo?.reportColumns) {
      this.drilldownColumnInfo = Object.values(this.drilldownColumnInfo.reportColumns);
      // Store report name in drilldownReportInfo
      this.drilldownReportInfo.reportName = originalDrilldownColumnInfo.reportName;
      this.drilldownReportInfo.columnName = this.getColumnInfo(column)?.columnName;
    }

    // Create array with item.id from reportColumns object
    this.drilldownReportInfo.columnsList = this.drilldownColumnInfo
      ? this.drilldownColumnInfo.map((item: any) => item.id)
      : [];
    
    let drilldownObject: any = [];
    if (Object.keys(hierarchicalDrilldownObject).length > 0) {
      drilldownObject.push(hierarchicalDrilldownObject);
    } else {
      drilldownObject = this.buildDrilldownObject(row, column, level, parentGroups);
    }
    //return;
    this.drilldownReportInfo.drilldownObject = drilldownObject;
    this.drilldownReportPostData = await this.getReportFormData('', 0);
    this.drilldownReportPostData.drilldownReportInfo = this.drilldownReportInfo;
    // Show the drilldown drawer
    this.drilldownReportInfo.visible = true;
  }

  async getDrilldownColumns(drilldownObject: any = {}): Promise<any> {
    return new Promise((resolve) => {
      this._commonHttpService.getDrilldownColumns(drilldownObject).subscribe((res: any) => {
        if (res.success == 1) {
          resolve(res.reportInfo);
        } else {
          resolve([]);
        }
      }, (error) => {
        resolve([]);
      });
    });
  }
  closeColumnFilter(columnFilter: any) {
    columnFilter.hide();
  }
  closeDatePicker() {
    // Close the date picker by setting overlayVisible to false
    if (this.multiDatePicker) {
      this.multiDatePicker.overlayVisible = false;
    }
  }

  /**
   * Checks if both start and end dates are selected in the date range
   * @returns boolean indicating if both dates are present
   * @author: PRachethan | 04-09-2025
   */
  isDateRangeValid(): boolean {
    return !!(this.dateRange &&
      this.dateRange.length === 2 &&
      this.dateRange[0] &&
      this.dateRange[1]);
  }


  showFooter() {
    const validReportIds = [9, 11, 15, 16, 7, 17];
    const isSummaryOrDimensionReport = this.reportFormData.reportType == ReportType.SUMMARY_REPORT || this.reportFormData.reportType == ReportType.DIMENSION_REPORT;
    const reportId = Number(this.reportFormData?.reportId || 0);
    return isSummaryOrDimensionReport || validReportIds.includes(reportId);
  }

  /**
   * Checks if pagination should be disabled for specific report IDs
   * @returns boolean indicating if pagination should be disabled
   * @author: Assistant | Current Date
   */
  shouldDisablePagination(): boolean {
    return [62, 109, 110].includes(Number(this.reportFormData?.reportId));
  }

  /**
   * Table scroll height. When pagination is hidden, reclaim the paginator block space.
   * Paginator approx height: 0.75rem padding top/bottom + ~26px controls ≈ 50px.
   */
  getTableScrollHeight(): string {
    if (this.shouldDisablePagination()) {
      return 'calc(70vh + 50px)';
    }
    return '70vh';
  }

  /**
   * Shows the custom report API popup
   * @author: Assistant | Current Date
   */
  showCustomReportApi(event?: Event) {
    event?.preventDefault();

    const savedReport = this.savedReportData?.savedReports?.[0];
    if (!savedReport) {
      this._commonMethods.showToastMessage('Report data not available', 'Error', Severity.error);
      return;
    }

    if (savedReport.encryptedId) {
      this.customReportApiPopup = true;
      return;
    }

    this.customReportApiLoading = true;
    this._spinnerService.withSpinner(
      this._commonHttpService.generateCustomReportApi(savedReport.id),
      'Generating API...'
    ).subscribe({
      next: (res: any) => {
        this.customReportApiLoading = false;
        if (res?.status === 1 && res?.data?.encryptedId) {
          savedReport.encryptedId = res.data.encryptedId;
          this.customReportApiPopup = true;
        } else {
          this._commonMethods.showToastMessage(res?.message || 'Unable to generate API URL', 'Error', Severity.error);
        }
      },
      error: () => {
        this.customReportApiLoading = false;
      }
    });
  }

  /**
   * Copies the report API URL to clipboard
   * @author: Assistant | Current Date
   */
  async copyReportApiUrl() {
    if (!this.savedReportData?.savedReports?.[0]?.encryptedId) {
      this._commonMethods.showToastMessage('Report data not available', 'Error', Severity.error);
      return;
    }
    const apiUrl = `${this.apiConfigUrl}/report-details/get-report-data/${this.savedReportData.savedReports[0].encryptedId}?response_type=1`;
    console.log('apiUrl', apiUrl);
    try {
      await navigator.clipboard.writeText(apiUrl);
      this._commonMethods.showToastMessage('API URL copied to clipboard', 'Success', Severity.success);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = apiUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      this._commonMethods.showToastMessage('API URL copied to clipboard', 'Success', Severity.success);
    }
  }

  /**
   * Downloads the report API URL as a doc file
   * @author: Assistant | Current Date
   */
  downloadReportApiUrl() {
    if (!this.savedReportData?.savedReports?.[0]?.encryptedId) {
      this._commonMethods.showToastMessage('Report data not available', 'Error', Severity.error);
      return;
    }

    this._commonHttpService.getApiConfig().subscribe((res: any) => {
      this.apiConfig = res.data.apiConfig;
      if (this.apiConfig.globalUser && this.apiConfig.globalCompany) {

        const apiUrl = `${this.apiConfigUrl}/report-details/get-report-data/${this.savedReportData.savedReports[0].encryptedId}?response_type=1`;
        const reportName = this.savedReportData.savedReports[0].reportName || 'Report';
        // Create document content for DOC file
        let fileData = `API Documentation
================

Report: ${reportName}
Generated: ${new Date().toLocaleString()}

API NAME: Custom Reports API

Authentication Details:
-----------------------
Authentication Url: ${this.createAuthTokenUrl}`;
        if (this.apiConfig?.globalUser?.email_id) {            
          fileData += `
Username: {email: ${this.apiConfig.globalUser.email_id}}
Password: {password: ****} (Get password details from Application)`;
        }
        
        if (this.apiConfig?.globalCompany?.apiKey) {
          fileData += `
Auth Key: {apiKey: ${this.apiConfig.globalCompany.apiKey}}`;
        }
        
        fileData += `Instructions:
-------------
Generate auth token using this authentication and use this auth token to get the access for below API.

API Endpoint Details:
--------------------
Authentication type: bearer token
token: Token generated from authentication
Method: GET
Endpoint URL: ${apiUrl}

Usage Example:
--------------
GET ${apiUrl}

Notes:
------
- Include proper authentication headers when making requests
- The encryptedId parameter is required for data access
- API returns data in JSON format by default

Generated on: ${new Date().toLocaleString()}`;

        // Create and download the file as DOC
        const blob = new Blob([fileData], { type: 'application/msword' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${reportName.replace(/[^a-z0-9]/gi, '_').toLowerCase()}_api_documentation.doc`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        this._commonMethods.showToastMessage('API documentation downloaded', 'Success', Severity.success);    
      }  
    });
  }

  /**
   * Shows the mobile report
   * @author: Raghavender P | 18-09-2025
   */
  async showMobileReport() {
    this.mobileReportInfo = await this.getReportFormData('', 0);
    const { columns, groupByFilters, groupByColumnsList, columnsList } = await this.getMobileReportColumns(this.mobileReportInfo);
    this.mobileReportInfo.groupByColumnsList = groupByColumnsList;
    this.mobileReportInfo.columnsList = columnsList;
    this.mobileReportInfo.groupByFilters = groupByFilters;
    this.mobileReportInfo.columns = columns;
    this.mobileReportInfo.visible = true;
    this.mobileReportInfo.getColumnInfo = this.getColumnInfo.bind(this);
    this.mobileReportInfo.allColumnsData = this.allColumnsData;
    this.mobileReportInfo.userConfig = this.userConfig;
    this.mobileReportInfo.reportConfig = this.reportConfig;
    this.mobileReportInfo.dimensionColumnsOptions = this.dimensionColumnsOptions;
    this.mobileReportInfo.orgGroupByFilters = {...this.mobileReportInfo.groupByFilters};
    this.mobileReportInfo.orgColumns = {...this.mobileReportInfo.columns};
    //this._commonService.showMobileReport();
  }

  async getMobileReportColumns(mobileReportInfo: any): Promise<any> {
    return new Promise((resolve) => {
      const MAX_MOBILE_REPORT_COLUMNS = 5;
      const tempReportFormData: any = { ...this.savedReportData.savedReports[0] };
      let { columns, groupByFilters } = this.savedReportService.processSavedReportColumns(tempReportFormData, true, this.allColumnsData, this.dimensionColumnsOptions);
      let groupByColumnsList = (mobileReportInfo.groupByColumnsList?.length > 0) ? mobileReportInfo.groupByColumnsList.slice(0,1) : [];
      let columnsList = (mobileReportInfo.columnsList?.length > 0) ? mobileReportInfo.columnsList.slice(0, MAX_MOBILE_REPORT_COLUMNS - groupByColumnsList.length) : [];

      if (tempReportFormData.mobileReportEnabled == 1) {
        // Override mobileReportColName in columns
        Object.values(columns).forEach((column: any) => {
          if (column.mobileReportCol == 1) {
            column.columnName = column.mobileReportColName;
          }
        });
        
        // Override mobileReportColName in groupByFilters
        Object.values(groupByFilters).forEach((column: any) => {
          if (column.mobileReportCol == 1) {
            column.columnName = column.mobileReportColName;
          }
        });
        
        columnsList = Object.values(columns).filter((column: any) => column.mobileReportCol == 1).sort((a: any, b: any) => a.mobileReportColOrder - b.mobileReportColOrder).map((column: any) => (mobileReportInfo.reportType == ReportType.DIMENSION_REPORT) ? 'd' + column.columnId : column.columnId);
        groupByColumnsList = Object.values(groupByFilters).filter((column: any) => column.mobileReportCol == 1).sort((a: any, b: any) => a.mobileReportColOrder - b.mobileReportColOrder).map((column: any) => column.columnId);
      }
      
      const result = { columns, groupByFilters, groupByColumnsList, columnsList };
      resolve(result);
    });
  }
  get filteredDateRanges(): any[] {
    // Hide YTD and All options based on report ID conditions
    if (this.reportFormData.reportId === 23) {
      return this.defaultDateRanges.filter(range => range.code !== '12' && range.code !== '18');
    }
    return this.defaultDateRanges;
  }

  async getDrilldownReportInfo(drilldownObject: any) {
    this.getDrilldownReport({}, drilldownObject.filterColumn, 0, drilldownObject);
  }
  
  jobDescriptionColumn: number[] = [1114, 975, 2156, 2191];

  // Columns that do not support sort / null filtering in the column filter panel
  sortNullFilterDisabledColumns: number[] = [2187];

  isSortNullFilterDisabled(columnId: any): boolean {
    return this.sortNullFilterDisabledColumns.includes(Number(columnId));
  }
  
  inArray(value: any, array: any[]): boolean {
    return array.includes(value);
  }
  
  getJobDescription(rowData: any, column: any) {
    let primaryKey;
    if (column == 2191) {
      const columnIndex = this.getUnifiedTableColumns().findIndex((col: any) => col == column);
      primaryKey = columnIndex >= 0 ? rowData[columnIndex] : undefined;
    } else {
      primaryKey = rowData[rowData.length - 1]?.col__org_0;
    }
    const dataToSend = {
      primaryKey: primaryKey,
      column: column,
    }
    this._commonHttpService.getJobDescription(dataToSend).subscribe({
      next: (res: any) => {
        if (res.status == 1) {
          this.currentJobTitle = res.data?.jobTitle || res.data?.title || '';
          this.currentJobDescription = res.data?.jobDescription || res.data?.description || '';
          this.jobCode = res.data?.jobCode;
          this.notesCreatedAt = res.data?.createdAt || '';
          this.notesDescription = res.data?.noteDescription ? res.data?.noteDescription :'';
          this.notesCreatedBy = res.data?.CreatedBy || '';
          this.showJobDescriptionPopup = true;
        } else {
          // Still open the popup with the message or data if available
          this.currentJobTitle = res.data?.jobTitle;
          this.currentJobDescription = res.message || res.data?.requistion_description || '';
          this.showJobDescriptionPopup = true;
        }
      },
      error: (error) => {
        this.currentJobTitle = 'Error';
        this.currentJobDescription = 'Failed to load job description. Please try again.';
        this.showJobDescriptionPopup = true;
      }
    });
  }
  onJobDescriptionPopupHide() {
    this.showJobDescriptionPopup = false;
    this.currentJobTitle = '';
    this.currentJobDescription = '';
    this.jobCode = '';
    this.notesCreatedBy = '';
    this.notesCreatedAt = '';
    this.notesDescription = '';
  }
  checkExportPermission(): boolean {
    return (this.reportConfig.reportModuleSecurity && (this.reportConfig.reportModuleSecurity.exportPermission == 1 || this.reportConfig.reportModuleSecurity.fullAccess == 1));
  }

  checkCustomReportApiPermission(): boolean {
    return ![9, 23, 62].includes(Number(this.reportFormData?.reportId)) && this.enableCustomReportApi;
  }
 
}
